<template>
    
  <div class="container" width="400" v-if="['A'].find(el=>el==store.state.user.groupe)">

        <!-- <h4 style="text-align: center;">{{store.state.frep.title.libelle}}</h4>
        <h4 style="text-align: center;">{{ store.state.frep.title.saison }}</h4>
        <h6 style="text-align: center;">{{ store.state.frep.title.dateModif }}</h6>
        <div  class="input-group input-group-sm mb-3">
            <button style="width: 150px;" @click="getCommandeNegoce(numneg)" class="btn btn-outline-secondary" type="button" id="button-addon1">getCommandeNegoce</button>
            <input v-model="numneg"  class="form-control form-control-sm" type="text" >
        </div> -->
        
    <!-- </v-card> -->
    <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
    <!-- <div >
      <v-checkbox
        v-model="readonly"
        label="Readonly"
      ></v-checkbox>
    </div> -->
    <v-expansion-panels
    >
        
    </v-expansion-panels>
        
    <v-expansion-panels
      v-model="panel"
      :readonly="false"
      multiple
    >
        <!-- <v-expansion-panel>
        <v-expansion-panel-title >ENTETE</v-expansion-panel-title>
        <v-expansion-panel-text>
            <table border="1" cellspacing="0" cellpadding="5">
                <tbody>
                    <tr >
                        <td style="border: 1;" width="300"><img src="C:/etlMyedisacData/adint.png" alt=""></td>
                        <td style="border: 1;" width="600" >
                            <h6>AD INTERNATIONAL</h6>
                            <p>Parc d'activité de la verte rue  52 Allée des Prêles</p>
                            <p>59270 Bailleul - FRANCE</p><p>TVA : FR-14-419-363-916</p>
                            <p>Tel : +33 (0)3 28 42 56 94</p>
                        </td>
                        <td style="border: 1;" width="300">
                            <div><h6>Distributeur de la marque</h6>
                                </div>   
                            <div><img src="C:/etlMyedisacData/woomen.png" alt="" width="300"></div> 
                        </td>
                    </tr>
                    
                </tbody>
            </table>  
        </v-expansion-panel-text>
        </v-expansion-panel>  -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-title>Fourisseur</v-expansion-panel-title>
        <v-expansion-panel-text>
            <table border="1" cellspacing="0" cellpadding="5">
                <tbody>
                    <tr >
                        <th width="300">DATE :</th>
                        <td width="300"><input type="date" :disabled="authorized" v-model="frep.fournisseur.date"></td>
                        <th width="300">NOM CLIENT</th>
                        <td width="300"><input type="text" :disabled="authorized" v-model="frep.fournisseur.nomClient"></td>
                    </tr>
                    <tr >
                        <th >CODE CLIENT :</th>
                        <td > <input type="text" :disabled="authorized" v-model="frep.fournisseur.codeClient"></td>
                        <th >CODE AGENT </th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.fournisseur.codeAgent"></td>
                    </tr>
                    <tr >
                        <th >AGENT :</th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.fournisseur.agent"></td>
                        <th >LIB COMMANDE :</th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.fournisseur.libCommande"></td>
                    </tr> 
                </tbody>
            </table>
        </v-expansion-panel-text>
      </v-expansion-panel> -->
      <!-- <v-expansion-panel>
        <v-expansion-panel-title>Client</v-expansion-panel-title>
        <v-expansion-panel-text>
            <table border="1" cellspacing="0" cellpadding="5">
                <tbody>
                    <tr >
                        <th width="300">ENSEIGNE :</th>
                        <td width="300"><input type="text" :disabled="authorized" v-model="frep.client.enseigne"></td>
                        <th width="300">CONTACT :</th>
                        <td width="300"><input type="text" :disabled="authorized" v-model="frep.client.contact"></td>
                    </tr>
                    <tr >
                        <th >RAISON SOCIALE :</th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.client.raisonSociale"></td>
                        <th >EMAIL</th>
                        <td ><input type="email" :disabled="authorized" v-model="frep.client.email"></td>
                    </tr>
                    <tr >
                        <th >TVA OU SIRET :</th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.client.tvaSiret"></td>
                        <th >TELEPHONE</th>
                        <td ><input type="tel" :disabled="authorized" v-model="frep.client.telephone"></td>
                    </tr>
                    <tr >
                        <th >DATE DE LIVRASION :</th>
                        <td ><input  type="date" :disabled="authorized" v-model="frep.client.dateLivraison"></td>
                        <th >SITE INTERNET :</th>
                        <td ><input type="text" :disabled="authorized" v-model="frep.client.siteweb"></td>
                    </tr>
                    <tr >
                        <th >ADRESSE DE LIVRAISON * :</th>
                        <td colspan="3" ><input size="6" type="text" :disabled="authorized" v-model="frep.client.adresseLiv"></td>
                    </tr>
                    <tr >
                        <th >ADRESSE DE FACTURATION :</th>
                        <td colspan="3" ><input size="6" type="text" :disabled="authorized" v-model="frep.client.adresseFac"></td>
                    </tr>
                    <tr >
                        <th >CONSIGNES / REmarqueS :</th>
                        <td colspan="3"><input type="text" size="6" :disabled="authorized" v-model="frep.fournisseur.remarque"></td>
                    </tr>
                </tbody>
            </table>
        </v-expansion-panel-text>
      </v-expansion-panel> -->

      <v-expansion-panel>
        <v-expansion-panel-title>Articles </v-expansion-panel-title>
        <v-expansion-panel-text >
        <!-- <div  class="input-group input-group-sm mb-3"> -->
            <!-- <button style="width: 150px;" @click="getArticles()" class="btn btn-outline-secondary" type="button" id="button-addon1">getmarque</button>
            <input v-model="marque"  class="form-control form-control-sm" type="text" >
            <v-combobox
                clearable
                chips
                multiple
                label="marques"
                :items="store.state.marques"
                v-model="filtreParams.code_marque"
                variant="outlined"
                density="compact"
            ></v-combobox> -->
            <v-row style="margin-top: 10px">
                <v-col  cols="12" md="2" sm="12">
                    <v-btn @click="marque=filtreParams.code_marque.split('-')[0].trim();getArticles()"
                        color="success"
                    >
                        getmarque
                    </v-btn>
                </v-col>
                <v-col  cols="12" md="2" sm="12">
                    <v-combobox
                        clearable
                        chips
                        label="Marque"
                        :items="store.state.marques"
                        v-model="filtreParams.code_marque"
                        variant="outlined"
                        density="compact"
                    ></v-combobox> 
                </v-col>
                 
                <v-col  cols="12" md="2" sm="12">
                   <v-text-field 
                        clearable 
                        type="date" 
                        label="Date Début" 
                        density="compact"
                        variant="outlined"
                        @change.prevent="addDateLivraison($event.target.value)" 
                    >
                    </v-text-field>
                </v-col>
            </v-row>
            
            <!-- <input @change.prevent="addDateLivraison($event.target.value)"  class="form-control form-control-sm" type="date" > -->
        <!-- </div> -->
        <!-- <div class="input-group input-group-sm mb-3">
            <input @change.prevent="addDateLivraison($event.target.value)"  class="form-control form-control-sm" type="date" >
        </div>  -->
        <div style="overflow-y: auto;max-height: 900px;min-height: 300px;">
            <div class="container">
                <div style="position: sticky;top: 0;z-index: 2">
                    <table  style="border: 0.1em  solid">
                        <thead >
                            <tr >   
                                <th width="100" style="border: 0.1em  solid">theme</th> 
                                <th width="100" style="border: 0.1em  solid;" @click="rechercherArticleStatut={statut:false,msg:''};duppliquerArticleStatut={statut:false,msg:''};rechercherArticle='';dupplicateDialog=true;tab='dup1'" class="iconAdd"><v-icon class="iconAdd" icon="mdi-content-duplicate" ></v-icon></th>
                                <th width="100" style="border: 0.1em  solid;">Dés.</th>
                                <th width="100" style="border: 0.1em  solid;">couleur</th>
                                <th width="100" style="border: 0.1em  solid;">taille</th>
                                <th width="100" style="border: 0.1em  solid;" @click="rechercherArticleStatut={statut:false,msg:''};rechercherArticle='';dialogAjout=true;tab='art'" class="iconAdd"><v-icon class="iconAdd" icon="mdi-store-search" ></v-icon></th>
                                <th width="100" style="border: 0.1em  solid;">Statut</th>
                                <th width="100" style="border: 0.1em  solid;"></th>
                                <th width="100" style="border: 0.1em  solid;">Qte</th>
                                <th width="100" style="border: 0.1em  solid;">Prix Négoce</th>
                                <th width="100" style="border: 0.1em  solid;">Prix TTC </th>
                                <th width="100" style="border: 0.1em  solid;">Totale</th>
                            </tr>
                            <!-- <tr>
                                <th width="100" style="background-color:#FFF4D7">marque :</th>
                                <th width="200" style="background-color:#FFF4D7">{{getLibelleFournisseur(store.state.frep.articles,2).theme  }}</th>
                                <th width="100" style="background-color:#FFF4D7">Code marque :</th>
                                <th width="100" style="background-color:#FFF4D7">{{ getLibelleFournisseur(store.state.frep.articles,2).code_theme }}</th>
                                <th width="100" style="background-color:#FFF4D7">Qté marque :</th>
                                <th width="100" style="background-color:#FFF4D7">{{totaleTheme(store.state.frep.articles).qte }}</th>
                                <th width="100" style="background-color:#FFF4D7">Total HT marque :</th>
                                <th width="100" style="background-color:#FFF4D7">{{totaleTheme(store.state.frep.articles).totalht}} €</th>
                                <th width="200" style="background-color:#FFF4D7">Total HT Remisé marque :</th>
                                <th width="100" style="background-color:#FFF4D7">{{totaleTheme(store.state.frep.articles).totalhtremise}} €</th>
                                        
                            </tr> -->
                        </thead>
                    </table>
                </div>
                <div  v-for="theme in store.state.frep.articles">
                    <div style="min-width: 1200;">
                        <table>
                            <tbody>
                                <tr>
                                    <th width="100" style="background-color:#FFF4D7">marque :</th>
                                    <th width="100" style="background-color:#FFF4D7">{{getLibelleFournisseur(theme,2).theme  }}</th>
                                    <th width="100" style="background-color:#FFF4D7">Code marque :</th>
                                    <th width="100" style="background-color:#FFF4D7">{{ getLibelleFournisseur(theme,2).code_theme }}</th>
                                    <th width="100" style="background-color:#FFF4D7">Qté marque :</th>
                                    <th width="100" style="background-color:#FFF4D7">{{totaleTheme(theme).qte }}</th>
                                    <th width="100" style="background-color:#FFF4D7">Total HT marque :</th>
                                    <th width="200" style="background-color:#FFF4D7">{{totaleTheme(theme).totalht}} €</th>
                                    <th width="100" style="background-color:#FFF4D7">Total HT Remisé marque :</th>
                                    <th width="200" style="background-color:#FFF4D7">{{totaleTheme(theme).totalhtremise}} €</th>  
                                </tr>
                                <tr>
                                    <th width="100" style="background-color:#FFF4D7"><span><v-icon class="iconAdd" icon="mdi-plus" @click="dialogAjout=true;selectArticle(theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]])"></v-icon></span>{{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme}} : {{totaleTheme(theme).qte}} </th>
                                    <th width="100" style="background-color:#FFF4D7">{{ totaleTheme(theme).totalht }} €</th>
                                    <th width="100" style="background-color:#FFF4D7">{{ totaleTheme(theme).totalhtremise }} €</th>
                                    <th width="100" style="background-color:#FFF4D7"></th>
                                    <th width="100" style="background-color:#FFF4D7">Composition : </th>
                                    <th width="100" style="background-color:#FFF4D7">{{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].code_composition }}</th>
                                    <th width="100" style="background-color:#FFF4D7">Code thème:</th>
                                    <th width="200" style="background-color:#FFF4D7">{{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].code_theme}} </th>
                                    <th width="100" style="background-color:#FFF4D7">Rayon :</th>
                                    <th width="200" style="background-color:#FFF4D7" colspan="4">{{ theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].code_rayon }} </th>
                                </tr>
                                
                            </tbody>
                            
                        </table>
                        
                    </div>
                
                    <div  v-for="refs in theme" >
                        <table  style="min-width: 1200;">
                            <tbody style="border: 0.1em  solid;">
                                <tr>
                                    <th width="100"  style="border: 0.1em  solid;background-color:#DDE2ED;">Produit</th>
                                    <th width="50" colspan="1" style="border: 0.1em  solid;background-color:#DDE2ED;" class="iconAdd" @click="dialogAjout=true;selectArticle(refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].code_theme)"><v-icon class="iconAdd" icon="mdi-plus" ></v-icon>Réf AD</th>
                                    <th  width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">Rayon</th>
                                    <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">Famille</th>
                                    <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">S-Famille</th>
                                    <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">Poids_Kg</th>
                                    <th :colspan="store.state.dateLivraisons.length+1" style="overflow-y: auto;border: 0.1em  solid;background-color:#DDE2ED;" width="50">Désignation</th>
                                    <th  width="100" style="border: 0.1em  solid;background-color:#DDE2ED;">Tailles Fourn
                                    </th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">Dimensions</th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">Fournisseur:</th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">Composition:</th>
                                    <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;" colspan="3">
                                        Repartition
                                    </th>
                                    
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">Cat. Douanie</th>

                                </tr>
                                <tr> 

                                    <th width="100" style="border: 0.1em   solid;background-color:#DDE2ED;" @dblclick="deleteDialog=true;articleToDelete={type:'ref',art:refs[Object.keys(refs)[0]]}"><input size="10" v-model="refs[Object.keys(refs)[0]].ref_fourn" @change="setInfoArticles('ref_fourn',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].ref_fourn)"></th>
                                    <th width="100" colspan="1" style="border: 0.1em  solid;background-color:#DDE2ED;" @dblclick="newRef=refs[Object.keys(refs)[0]];tab='seven';dialogAjout=true;modifRef=true" class="iconAdd">{{refs[Object.keys(refs)[0]].reference_y2  }}</th>
                                    <th class="iconAdd" width="50" style="border: 0.1em  solid;background-color:#DDE2ED;"
                                        @click="dialogAjout=true;tab='eight';classifications={type:'code_rayon',art:refs[Object.keys(refs)[0]],tab:rayonTab}">
                                        <!-- <select id="produits" name="produits" @change="filterSousFamille($event.target.value)" v-model="refs[Object.keys(refs)[0]].code_rayon">
                                            <option  v-for="key in rayonTab">{{key.code}}</option>
                                        </select> -->
                                        {{ refs[Object.keys(refs)[0]].code_rayon }}
                                    </th>
                                    <th class="iconAdd" width="50" style="border: 0.1em  solid;background-color:#DDE2ED;"
                                        @click="dialogAjout=true;tab='eight';classifications={type:'code_famille',art:refs[Object.keys(refs)[0]],tab:familleTab.filter((el)=>{ return el.code.match(new RegExp(`^${(refs[Object.keys(refs)[0]]?.code_rayon ?? '')}`))})}">
                                        <!-- <select id="produits" name="produits"  v-model="refs[Object.keys(refs)[0]].code_famille">
                                            <option  v-for="key in sousFamilleTabFilter">{{key.code}}</option>
                                        </select> -->
                                        {{ refs[Object.keys(refs)[0]].code_famille }}
                                    </th>
                                    <th class="iconAdd" @click="dialogAjout=true;tab='eight';classifications={type:'code_sousfamille',art:refs[Object.keys(refs)[0]],tab:sousFamilleTab.filter((el)=>{ return el.code.match(new RegExp(`^${(refs[Object.keys(refs)[0]]?.code_famille ?? '')}`))})}" width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">
                                        {{ refs[Object.keys(refs)[0]].code_sousfamille }}
                                    </th>
                                    <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">
                                        <input size="4" v-model="refs[Object.keys(refs)[0]].poidsnet" @change="setInfoArticles('poidsnet',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].poidsnet)">   
                                    </th>
                                    <th :colspan="store.state.dateLivraisons.length+1" style="border: 0.1em  solid;background-color:#DDE2ED;max-width: 200;" width="50"><input v-model="refs[Object.keys(refs)[0]].designation" @change="setInfoArticles('designation',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].designation)"></th>
                                    <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;" >
                                        <select id="produits" name="produits">
                                            <option value="">-- Sélectionnez --</option>
                                            <option value="Stylo">Stylo</option>
                                            <option value="taille-crayon">taille-crayon</option>
                                        </select>
                                    </th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">
                                        <input size="9" v-model="refs[Object.keys(refs)[0]].dimension" @change="setInfoArticles('dimension',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].dimension)">
                                        <!-- <input size="2" v-model="refs[Object.keys(refs)[0]].poidsnet" @change="setInfoArticles('poidsnet',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].poidsnet)"></input> -->
                                    </th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;"><input size="10" v-model="refs[Object.keys(refs)[0]].code_fourn" @change="setInfoArticles('code_fourn',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].code_fourn)"></th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].code_composition }}</th>
                                    <th width="100"  style="max-width: 100px; ;border: 0.1em  solid;background-color:#DDE2ED; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"  colspan="3" @click="repartDialog=true;articleRepart={type:'ref',art:refs[Object.keys(refs)[0]]}">
                                        <table border="1">
                                            <tbody>
                                                <tr>
                                                    <td style="max-width: 200px; padding: 0;">
                                                    <div style="overflow-x: auto; white-space: nowrap; max-width: 200px;">
                                                    {{ repartLigne(refs[Object.keys(refs)[0]].repart) }}
                                                    </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    
                                    </th>
                                    <th width="70" style="border: 0.1em  solid;background-color:#DDE2ED;">
                                        <input size="10" v-model="refs[Object.keys(refs)[0]].code_catdouanie" @change="setInfoArticles('code_catdouanie',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].code_catdouanie)">
                                    </th>
                                </tr>
                                <tr>
                                    <th width="100"  style="border: 0.1em solid; background-color:#E6F3E6;">Image
                                        <!-- <img style="border: 1px solid grey;padding: 1px;" @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`" v-if="refs[Object.keys(refs)[0]].imagename" :src="`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`"  width="100px" height="70px"> -->
                                    
                                    </th>
                                    <!-- <th width="20" @click="dialogAjout=true;selectArticle(refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].code_theme,refs[Object.keys(refs)[0]].reference_y2)" ><v-icon icon="mdi-plus" ></v-icon></th> -->
                                    <th width="50" :colspan="refs[Object.keys(refs)[0]].taille?0:3"  style="border: 0.1em  solid; background-color:#E6F3E6;" class="iconAdd"  @click="dialogAjout=true;selectArticle(refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].code_theme,refs[Object.keys(refs)[0]].reference_y2)" ><v-icon icon="mdi-plus" ></v-icon>couleur </th>
                                    <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">taille</th>
                                    <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">T. Fourn</th>
                                    <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Repart</th>
                                    <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Collect.</th>
                                    <th v-for="date in store.state.dateLivraisons" style="border: 0.1em  solid; background-color:#E6F3E6;" width="50" @dblclick="deleteDialog=true;articleToDelete={type:'date',art:date}">{{date.length!=8? excelDateToYYYYMMDD(date):date }}</th>
                                    <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Qte</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Achat Devise</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Achat HT</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Remise ligne</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix de revient</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Public</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Promo</th>
                                    <th width="70" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Négoce</th>
                                    <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Total Achat HT</th>

                                </tr>
                                <tr >
                                    <th  :rowspan="Object.keys(refs).length+2" valign="top" style="border: 0.1em  solid;background-color:#B0C4E9;" width="100">
                                        <img style="border: 1px solid grey;padding: 1px;" @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`" v-if="refs[Object.keys(refs)[0]].imagename" :src="`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`"  width="100px" height="70px">
                                    
                                    </th>
                                    <th :colspan="refs[Object.keys(refs)[0]].taille?'':3" width="100"  style="background-color:#B0C4E9;max-height: 10px;" >{{ getColorNumber(refs).color }}</th>
                                    <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">{{getColorNumber(refs).taille}}</th>
                                    <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">T. Fourn</th>
                                    <th width="50" style="border: 0.1em  solid; background-color:#B0C4E9;">Repart</th>
                                    <th width="50" style="border: 0.1em  solid; background-color:#B0C4E9;">
                                        <select name="collections" id="collections" v-model="refs[Object.keys(refs)[0]].collection" @change="setInfoArticles('collection',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].collection)">
                                            <option  v-for="key in collections">{{key}}</option>
                                        </select>
                                    </th>
                                    <th v-for="date in store.state.dateLivraisons" style="border: 0.1em  solid;background-color:#B0C4E9;" width="50">{{totalRef(refs,date).qte}}</th>
                                    <th width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">{{totalRef(refs).qte}}</th>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].achat_devise" @change="setPrices('achat_devise',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].achat_devise)"><span >$</span></td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].achat_euro" @change="setPrices('achat_euro',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].achat_euro)"><span >€</span></td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].remise_ligne" @change="setPrices('remise_ligne',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].remise_ligne)"><span >%</span></td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;">{{ ((1-(refs[Object.keys(refs)[0]].remise_ligne?refs[Object.keys(refs)[0]].remise_ligne:0)/100)*refs[Object.keys(refs)[0]].achat_euro).toFixed(2) }}</td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].vte_euro" @change="setPrices('vte_euro',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].vte_euro)"><span >€</span></td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].prix_promo" @change="setPrices('prix_promo',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].prix_promo)"><span >€</span></td>
                                    <td width="70" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="refs[Object.keys(refs)[0]].prix_negoce" @change="setPrices('prix_negoce',refs[Object.keys(refs)[0]],refs[Object.keys(refs)[0]].prix_negoce)"><span >€</span></td>
                                    <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;"><input size="6" v-model="totalRef(refs).totalht"><span >€</span></td>
                                    
                                </tr>
                                
                                <tr v-for="article in trierObjetParcouleurEttaille(refs)" :style="[article.STATUT=='new'?{'background-color':'orange'}:{'color':'green'}]">
                                    <td width="100"  :colspan="refs[Object.keys(refs)[0]].taille?0:3" style="border: 0.1em  solid;"><span @dblclick="deleteDialog=true;articleToDelete={type:'color',art:article}">{{`${article.code_couleur}-${article.couleur}`}}</span></td>
                                    <td v-if="refs[Object.keys(refs)[0]].taille" width="50"  style="border: 0.1em  solid;" >{{article.taille}}</td>
                                    <td v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;" >{{article.taille}}</td>
                                    <td width="50" class="iconAdd" style="border: 0.1em  solid;" @click="repartDialog=true;articleRepart={type:'color',art:article}">Repart</td>
                                    <td width="50" class="iconAdd" style="border: 0.1em  solid;">
                                        <select name="collections" id="collections" v-model="article.collection">
                                            <option  v-for="key in collections">{{key}}</option>
                                        </select>
                                    </td>
                                    <td v-for="date in store.state.dateLivraisons"  width="50" :style="[article[date]&&article[date].export?{'background-color':'orange','border': '0.1em solid'}:{'border': '0.1em solid'}]"><input min="0" size="6" style="width: 90%" :disabled="article[date]&&article[date].export" type="number" v-model="article[date].qte"></td>
                                    <td width="50" style="border: 0.1em  solid;">{{ qteDateLivraison(article) }}</td>
                                    <td widtd="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.achat_devise" @change="setPrices('achat_devise_dim',article,article.achat_devise)"><span >$</span></td>
                                    <td widtd="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.achat_euro"><span >€</span></td>
                                    <td widtd="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.remise_ligne"><span >%</span></td>
                                    <td widtd="70" style="border: 0.1em  solid;">{{ ((1-(article.remise_ligne?article.remise_ligne:0)/100)*article.achat_euro).toFixed(2) }}</td>
                                    <td widtd="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_euro"><span >€</span></td>
                                    <td width="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.prix_promo"><span >€</span></td>
                                    <td width="70" style="border: 0.1em  solid;"><input min="0" size="6" style="width: 70%;" type="number" v-model="article.prix_negoce"><span >€</span></td>
                                    <td width="100" style="border: 0.1em  solid;"><input min="0" step="2" size="6" disabled style="width: 70%;" type="number" :value="qteDateLivraison(article)*article.achat_euro"><span >€</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            <!-- <div>
                <table>
                    <tbody style="border: 0.1em  solid;">
                        <tr><th width="100"></th>
                            <th width="100"></th>
                            <th width="50" style="text-align: right; "></th>
                            <th width="50" style="text-align: right; "></th>
                            <th width="50" style="text-align: center; ">Totale</th>
                            <th v-for="date in dateLivraisons" width="50" style="text-align: center; ">{{totaleQteCde(theme,date)}}</th>
                            <th width="50">{{totaleQteCde(theme)}}</th>
                            <th width="700"></th>
                            </tr>
                    </tbody>
                </table>
                
            </div>   -->
            <v-divider class="border-opacity-25"></v-divider>
            
           </div>
             </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody style="border: 0.1em  solid;">
                        <tr @click="statDialog=true">
                            <td width="400" rowspan="5" colspan="6" style="border: 0.1em  solid;" class="chart-container">
                                <Pie   :data="chartData" :options="chartOptions" />
                            </td>
                            <td colspan="6" height="20">  </td> 
                        </tr>
                        <tr >   
                            <td width="400"></td>
                            <th width="100">TOTAL QUANTITES :</th>
                            <th width="100">{{ totalCommande(store.state.frep.articles).qte}}</th>
                            <th width="200" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100">{{ totalCommande(store.state.frep.articles).totalht }}€</th>
                            </tr>
                        <tr > 
                            <td width="100"></td>
                            <th width="100"></th>
                            <th width="100"></th>
                            <th width="100" style="text-align: right; ">FRAIS DE PORT:</th>
                            <th width="100" ><input min="0"  size="2" style="width: 70px;" type="number" v-model="store.state.frep.fraisPort">€</th>
                        </tr>
                        <tr >   
                            <td width="100"></td>
                            <th width="100" ></th>
                            <th width="100" ></th>
                            <th width="200" style="text-align: right; ">TOTAL CDE HT :</th>
                            <th width="100">{{ (Number(totalCommande(store.state.frep.articles).totalht)+Number(store.state.frep.fraisPort)).toFixed(2) }}€</th>
                            </tr>
                        
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600" style="text-align: center ;border: 0.1em  solid;">CONDITIONS COMMERCIALES NEGOCE - 2026 France métropolitaine (hors Corse) et Belgique</td>
                            <td width="100"></td>
                            <td width="500"  >Je reconnais avoir reçu et pris connaissance des CONDITIONS GENERALES DE VENTE</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                         <tr>
                            <td width="100"   > </td>
                            <td width="100"  > </td>
                            <td width="100"   > </td>
                            <td width="100"   > </td>
                            <td width="100"   > </td>
                            <td width="100"   > </td>
                            <td width="100"   > </td>
                            <td  width="500"  rowspan="3">
                                <div style="border: 0.1em  solid;" v-if="store.state.frep.signature.exist" >
                                    <v-card v-if="store.state.frep.signature.exist"  >
                                        <img :src="store.state.frep.signature.link" ></img>
                                    </v-card>
                                </div>
                                <Vue3Signature  v-if="!store.state.frep.signature.exist" style="border: 0.1em  solid;"  ref="signature1" :sigOption="state.option" :w="'500px'" :h="'100px'">
                                </Vue3Signature>
                                
                            </td>
                        </tr> 
                        <tr>
                            <td width="100" height="20" style="border: 0.1em  solid;" >coef 2.8</td>
                            <td width="100"  style="border: 0.1em  solid;" >MIN COMMANDE MEP</td>
                            <td width="100"  style="border: 0.1em  solid;" >FRANCO MEP</td>
                            <td width="100"  style="border: 0.1em  solid;" >MIN REA</td>
                            <td width="100"  style="border: 0.1em  solid;" >FRANCO REA</td>
                            <td width="100"  style="border: 0.1em  solid;" >PORT</td>
                            <td width="100"   > </td>
                        </tr>
                        <tr>
                            <td width="100" height="20" style="border: 0.1em  solid;" >MAROQUINERIES</td>
                            <td width="100"  style="border: 0.1em  solid;" >500 € HT</td>
                            <td width="100"  style="border: 0.1em  solid;" >1000 € HT</td>
                            <td width="100"  style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100"  style="border: 0.1em  solid;" >250 € HT</td>
                            <td width="100"  style="border: 0.1em  solid;" >20 € HT</td>
                            <td width="100"   > </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            <div>
                <table  cellspacing="0" cellpadding="10">
                    <tbody >
                        <tr>
                            <td width="600"></td>
                            <td width="100"></td>
                            <td width="500" >
                                <v-bottom-sheet inset>
                                    <template v-slot:activator="{ props: activatorProps }">
                                        <v-btn v-if="!store.state.frep.signature.exist"  v-bind="activatorProps" @click="save('./image.jpeg')" text="Signer"></v-btn>
                                    </template>
                                    <v-card
                                        title="Signature"
                                        text="Votre signature a été pris en compte!"
                                    ></v-card>
                                </v-bottom-sheet>
                            </td>
                        </tr>
                         
                    </tbody>
                </table>
            </div>
        
        <div style="text-align: center;">
             <v-row >
                <v-col cols="12"  md="1">
                    <v-btn @click="sendCommandeFrep()" color="sucess"> Valider</v-btn>

                </v-col> 
                <v-col cols="12"  md="1">
                    <v-btn @click="nouvelleCommande()" color="warning"> Nouvelle</v-btn>
                </v-col> 
             </v-row>
        </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div class="text-center" >
      <v-dialog v-model="dialogAjout" width="auto" >
        <v-card  :prepend-icon="tab!='art'?'mdi-plus':'mdi-store-search'" 
        :text="tab=='art'?`Veulliez saisir l'article à ajouter`:(tab=='three'?`Veulliez choisir le thème à ajouter`:(tab=='two'?`Veulliez choisir la référence à ajouter`:`Veuillez saisir la qté de chaque couleur`))"
        :title="tab!='art'?'Ajout Articles':'Recherche Article'"
        >
        <v-card >
            <v-card-text >
            <div v-if="tab=='art'" class="input-group input-group-sm mb-3">
                <input size="5"  v-model="rechercherArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
            </div>
            <div v-if="tab!='art'&&tab!='sixe'" class="input-group input-group-sm mb-3" height="10px">
                <button v-if="tab!='sixe'&&tab!='four'&&tab!=='two'" @click="addColor();tab='four'" class="btn btn-outline-secondary" type="button" id="button-addon1"><v-icon icon="mdi-plus" ></v-icon></button>
                <button v-if="tab!='sixe'&&tab!='four'&&tab=='two'" @click="addReference()" class="btn btn-outline-secondary" type="button" id="button-addon1">ref</button>
                <button v-if="tab=='four'" @click="goToColor()" class="btn btn-outline-secondary" type="button" id="button-addon1"><v-icon icon="mdi-plus" ></v-icon></button>
                <input   v-model="rechercher" placeholder="Faire une recherche"  class="form-control form-control-sm" type="text" >
                <div v-if="tab=='one'">
                    <input v-model="EAN13Choice" style="margin: 0.4rem;" type="checkbox" id="scales" name="scales" checked />
                    <label style="font:1rem Fira Sans,sans-serif;" for="scales">ean13</label>
                </div>
            </div>
            <v-card v-if="colorsToAddTabFilterSelected.length>0&&tab!='sixe'">
                <v-card elevation="4" class="pa-3" >
                    <v-container class="bg-lightblue py-6" >
                        <v-row dense>
                            <v-col  :cols="colorsToAddTabFilterSelected.length>1?2:6" v-for="color in colorsToAddTabFilterSelected">
                                <div class="input-group input-group-sm mb-1">
                                    <!-- <button @click="colorsToAddTabFilterSelected=colorsToAddTabFilterSelected.filter((el)=>el.code_couleur!=color.code_couleur)"   class="btn btn-outline-secondary" type="button" id="button-addon1">{{ color.code_couleur }}</button> -->
                                    <button style="width:200px;" @click="colorsToAddTabFilterSelected=colorsToAddTabFilterSelected.filter((el)=>el.code_couleur!=color.code_couleur)" class="btn btn-outline-secondary" type="button" id="button-addon1"><span style="width:90px;text-align: left;">{{ color.code_couleur }}</span>-<span style="width:110px;">{{ color.couleur }}</span></button>
                                    <!-- <input  disabled v-model="color.couleur"  class="form-control form-control-sm" type="text" > -->
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col  :cols="taillesToAddTabFilterSelected.length>1?1:6" v-for="taille in taillesToAddTabFilterSelected">
                                <div class="input-group input-group-sm mb-1">
                                    <button @click="taillesToAddTabFilterSelected=taillesToAddTabFilterSelected.filter((el)=>el.code_taille!=taille.code_taille)"   class="btn btn-outline-secondary" type="button" id="button-addon1">{{ taille.code_taille }}</button>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-card>
            <div v-if="rechercherArticleStatut.statut" style="text-align: center;color: red;">
                <p>{{ rechercherArticleStatut.msg }}</p>
            </div>
            <v-tabs-window v-model="tab" >
                <v-tabs-window-item value="one">
                    <v-card class="scroll-box">
                        <table height="auto">
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="input-group input-group-sm mb-3" style="position: sticky;  top: 0;  z-index: 2;">
                                            <div style="width: 250px;" ></div>
                                            <input disabled v-if="EAN13Choice" width="120px">
                                            <p  v-for="date in store.state.dateLivraisons" style="width: 100px; background-color: antiquewhite;;" >{{ date.length!=8? excelDateToYYYYMMDD(date):date }}</p>
                                            <div style="width: 50px;" ></div>
                                            <div style="margin-top: 8px;margin-left: 8px; background-color: antiquewhite;"></div>
                                        </div>
                                    </td>
                                </tr>
                                <tr  v-for="color in trierParCouleurEtTaille(articleToAddTabFilter)" >
                                    <td  >
                                        <div  class="input-group input-group-sm mb-3">
                                            <button
                                                :class="{
                                                    'btn-new': color?.new === 'nouveau',
                                                    'btn-find': articleFinded && (color?.ean13_y2 === articleFinded || color?.codebarre === articleFinded)
                                                }"
                                                :style="!(color.new && color.new == 'nouveau') ? { width: '250px' } : {}"
                                                @click="addQte(color)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ `${color.taille?color.code_couleur+"-"+color.couleur+"-"+color.taille:color.code_couleur+"-"+color.couleur}` }}</button>
                                            <input  v-if="EAN13Choice" :style="[checkingEAN13(color.ean13_y2).erreur?{'color':'red','width': '120px'}:{'color':'green','width': '120px'}]" v-model="color.ean13_y2"  class="form-control form-control-sm" type="text" ></input>
                                            <input v-for="date in store.state.dateLivraisons" style="width: 100px;" v-model="color[date].qte"  min="0" class="form-control form-control-sm" type="number" ></input>
                                            <button style="width: 50px;" @click="ean13Attribution(color)" class="btn btn-outline-secondary" type="button" id="button-addon1">ean</button>
                                            <span ><v-icon style="margin-top: 8px;margin-left: 8px;" :icon="etatStock(color).icon" size="small" :color="etatStock(color).color"></v-icon></span>
                                        </div>
                                        <p  v-if="EAN13Choice&&checkingEAN13(color.ean13_y2).erreur" style="color:red;height: 2px;text-align: center;">Vérifiez le code ean13</p>  
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card>   
                </v-tabs-window-item>
                <v-tabs-window-item value="two" scrollable>
                   <v-card class="scroll-box">
                    <table height="auto">
                        <tbody>
                            <tr v-for="ref in articleToAddTabFilter">
                                <td >
                                    <div class="input-group input-group-sm mb-3">
                                        <button style="width: 150px;" @click="tab='one';selectArticle(ref,ref.code_theme,ref.reference_y2 )" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ ref.reference_y2  }}</button>
                                        <input disabled style="width: 150px;" v-model="ref.ref_fourn"  class="form-control form-control-sm" type="text" >
                                        <input disabled style="width: 150px;" v-model="ref.designation"  class="form-control form-control-sm" type="text" >
                                   </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="three" height="400">
                    <v-card class="scroll-box">
                        <div v-for="theme in articleToAddTabFilter" style="margin-top: 1px;">
                            <div  class="input-group input-group-sm mb-3">
                                <button style="width: 150px;" @click="tab='one';selectArticle(theme,theme.code_theme)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ theme.code_theme  }}</button>
                                <input disabled="true" v-model="theme.theme"  class="form-control form-control-sm" type="text" >
                            </div>
                        </div>
                    </v-card>
                </v-tabs-window-item>
                <v-tabs-window-item value="four" scrollable >
                   <v-card class="scroll-box" >
                        <v-card elevation="4" class="pa-3" >
                          <v-container class="bg-lightblue py-6" >
                            <v-row dense>
                                <v-col  :cols="colorsToAddTabFilter.length>1?2:6" v-for="color in colorsToAddTabFilter">
                                    <div class="input-group input-group-sm mb-1">
                                        <button style="width:200px;" @click="addSelectedColor(color)" class="btn btn-outline-secondary" type="button" id="button-addon1"><span style="width:90px;text-align: left;">{{ color.code_couleur }}</span>-<span style="width:110px;">{{ color.couleur }}</span></button>
                                        <!-- <input style="width: 100px;" disabled v-model="color.couleur"  class="form-control form-control-sm" type="text" > -->
                                    </div>
                                </v-col>
                            </v-row>
                            </v-container> 
                        </v-card>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="five" scrollable>
                   <v-card class="scroll-box" style="min-width: 500px;">
                        <v-card elevation="4" class="pa-6" >
                          <v-container class="bg-lightblue py-1" >
                            <v-row dense>
                                <v-col  :cols="taillesToAddTabFilter.length>1?1:6" v-for="taille in taillesToAddTabFilter">
                                    <div class="input-group input-group-sm mb-1">
                                        <button  @click="addSelectedtaille(taille)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ taille.taille }}</button>
                                     </div>
                                </v-col>
                            </v-row>
                            </v-container> 
                        </v-card>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="sixe">
                   <v-card class="scroll-box">
                        <div class="input-group input-group-sm mb-3" style="position: sticky;text-align: center;  top: 0;  z-index: 2;">
                            <div style="width: 50px;" ></div>
                            <div style="width: 150px;background-color: antiquewhite;text-align: center;" >Code</div>
                            <div style="width: 150px;background-color: antiquewhite;text-align: center;" >couleur</div>
                        </div>
                        <div v-for="color in colorsToAddTabFilterSelected" class="input-group input-group-sm mb-3">
                            <button style="width: 50px;" @click="deleteNewColor(color)" class="btn btn-outline-secondary" type="button" id="button-addon1"><v-icon icon="mdi-delete-forever" ></v-icon></button>
                            <input disabled style="width: 150px;" v-model="color.code_couleur"  class="form-control form-control-sm" type="text" >
                            <input disabled style="width: 150px;" v-model="color.couleur"  class="form-control form-control-sm" type="text" >
                        </div>
                        <div  class="input-group input-group-sm mb-3">
                            <button style="width: 50px;" @click="addNewColor()" class="btn btn-outline-secondary" type="button" id="button-addon1"><v-icon icon="mdi-plus" ></v-icon></button>
                            <input style="width: 150px;" v-model="newColor.code_couleur"  class="form-control form-control-sm" type="text" >
                            <input style="width: 150px;" v-model="newColor.couleur"  class="form-control form-control-sm" type="text" >
                        </div>    
                    </v-card>
                </v-tabs-window-item>
                <v-tabs-window-item value="seven">
                   <v-card class="scroll-box">
                        <v-row dense>
                            <v-col  cols="12" md="2" sm="12">
                                <v-text-field clearable label="Ref AD Int" @input="newRef.reference_y2 = newRef.reference_y2.toUpperCase()"  v-model="newRef.reference_y2" variant="outlined" :rules="rules(newRef.reference_y2,'Ref AD INT','')" :style="[newRef.reference_y2?{'color':'green'}:{'color':'red'}]"></v-text-field>
                            </v-col>
                            <!-- <v-col  cols="12" md="2" sm="6">
                                <v-combobox clearable label="Rayon" :items="rayonTab" @change="filterSousFamille($event.target.value)" v-model="newRef.code_rayon" variant="outlined" :rules="rules(newRef.code_sousfamille,'SousFamille','')" :style="[newRef.code_sousfamille?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col> -->
                            <!-- <v-col  cols="12" md="2" sm="6">
                                <v-combobox clearable label="Famille" :items="familleTabFiltre" v-model="newRef.code_famille" variant="outlined" :rules="rules(newRef.code_sousfamille,'SousFamille','')" :style="[newRef.code_sousfamille?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col> -->
                            <v-col  cols="12" md="2" sm="6">
                                <v-combobox clearable label="Sous-Famille" :items="sousFamilleTabFilter" v-model="newRef.code_sousfamille" variant="outlined" :rules="rules(newRef.code_sousfamille,'SousFamille','')" :style="[newRef.code_sousfamille?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col>
                            <v-col  cols="12" md="2" sm="4">
                                <v-text-field clearable label="Désignation" v-model="newRef.designation"  variant="outlined" :rules="rules(newRef.designation,'Désignation','')" :style="[newRef.designation?{'color':'green'}:{'color':'red'}]"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="2" sm="4">
                                <v-combobox clearable label="Marques" :items="itemsmarques" v-model="newRef.code_marque" variant="outlined" :rules="rules(newRef.code_marque,'marques','')" :style="[newRef.code_marque?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col>
                
                            <v-col  cols="12" md="2" sm="6">
                                <v-combobox  clearable label="Thème" :items="itemsThemes" v-model="newRef.code_theme"  variant="outlined" :rules="rules(newRef.code_theme,'thème','')" :style="[newRef.code_theme?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col>
                            
                            <v-col  cols="12" md="2" sm="6">
                                <v-combobox clearable label="Composition" :items="itemsComposition" v-model="newRef.code_composition" variant="outlined" :rules="rules(newRef.code_composition,'Composition','')" :style="[newRef.code_composition?{'color':'green'}:{'color':'red'}]"></v-combobox>
                            </v-col>
                            
                            <v-col  cols="12" md="2" sm="6">
                                <v-text-field label="Prix Public TTC" variant="outlined" v-model="newRef.vte_euro" prefix="€" :rules="rules(newRef.vte_euro,'Prix PVC','^[0-9]*$')" :style="[newRef.vte_euro?{'color':'green'}:{'color':'red'}]"></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" md="2" sm="6">
                                <v-text-field label="Prix Achat" variant="outlined"  v-model="newRef.achat_euro"  prefix="€" :rules="rules(newRef.achat_euro,'Prix Achat','^[0-9]*[.,]?[0-9]*$')" :style="[newRef.achat_euro?{'color':'green'}:{'color':'red'}]"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="2" sm="6">
                                <v-text-field label="Poids" variant="outlined" v-model="newRef.poidsnet" prefix="kg" :rules="rules2(newRef.poidsnet,'Poids','^[0-9]*[.,]?[0-9]*$')"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="2" sm="6">
                                <v-text-field label="Dimensions" variant="outlined" v-model="newRef.dimension"  placeholder="L*H*P"  :rules="rules2(newRef.dimension,'Dimensions','^[0-9]*[*]*[0-9]*[*]*[0-9]$')"></v-text-field>
                            </v-col>
                            <v-col  cols="12"  md="2"  sm="6">
                                <v-text-field label="Volume" variant="outlined" v-model="newRef.volume" prefix="L" :rules="rules2(newRef.volume,'Volume','^[0-9]*[.,]?[0-9]*$')"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="2"  sm="6">
                                <v-text-field  label="Fournisseur" variant="outlined" v-model="newRef.code_fourn" :rules="rules(newRef.code_fourn,'Fournisseur','^[0-9]{6}$')"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-tabs-window-item>
                <v-tabs-window-item value="eight">
                   <v-card class="scroll-box">
                        <div v-for="classification in classifications.tab" style="margin-top: 1px;">
                            <div  class="input-group input-group-sm mb-3">
                                <button style="width: 70px;" @click="setClassification(classifications,classification)"  class="btn btn-outline-secondary" type="button" id="button-addon1">{{ classification.code  }}</button>
                                <input v-if="classification.fr" disabled v-model="classification.fr"  class="form-control form-control-sm" type="text" >
                                <input v-if="!classification.fr" disabled v-model="classification.libelle"  class="form-control form-control-sm" type="text" >
                            </div>
                        </div>
                   </v-card>
                </v-tabs-window-item>
            </v-tabs-window>
            </v-card-text>
        </v-card>
        <p v-if="ean13Statut" style="color: red;text-align: center;">Vérifiez que tous les articles possèdent des codes EAN13</p>
        <p v-if="chekingArt.statut" style="color: red;text-align: center;">{{ chekingArt.msg }}</p>
        <template v-slot:actions>
            <!-- <v-checkbox style="height:5px;margin-top: 0px;"  label="EAN13"></v-checkbox> -->
            <v-btn class="ms-auto" text="Annuler" @click="dialogAjout = false" style="text-align: left;"></v-btn>
            <v-btn v-if="tab!='art'&&tab!='four'&&tab!='five'&&tab!='sixe'&&tab!='seven'" class="ms-auto" text="Ajouter" @click="addArticle()"></v-btn>
            <v-btn v-if="tab=='art'" class="ms-auto" text="Chercher" @click="getArticle()"></v-btn>
            <v-btn v-if="tab=='five'&&tab!='art'" class="ms-auto" text="Créer" @click="chekingArtToAdd('taille')"></v-btn>
            <v-btn v-if="(tab=='sixe'||tab=='four')&&articleRef.code_rayon!='C'&&tab!='art'" class="ms-auto" text="Créer" @click="chekingArtToAdd('color')"></v-btn>
            <v-btn v-if="(tab=='sixe'||tab=='four')&&tab!='art'&&tab!='seven'" class="ms-auto" text="tailles" @click="gotTotailles()"></v-btn>
            <v-btn v-if="tab=='seven'&&tab!='art'&&!modifRef" class="ms-auto" text="Créer" @click="createReference()"></v-btn>
            <v-btn v-if="tab=='seven'&&tab!='art'&&modifRef" class="ms-auto" text="Valider" @click="validerModifRef()"></v-btn>
        </template>
        <v-card>

        </v-card>
            <p v-if="qteStatut" style="color:red;text-align: center;">Veuillez saisir la qté</p>
            <p v-if="checkingEan13Statut" style="color:red;text-align: center;">{{checkingEan13Statut.msg}}</p>
            <p v-if="refToCreate.statut" style="color:red;text-align: center;">{{ refToCreate.msg }}</p>
        </v-card>
      </v-dialog>
    </div> 
    <div class="text-center pa-4">
      <v-dialog
        v-model="dupplicateDialog"
        width="auto"
      >
      
        <v-card
          max-width="300"
          prepend-icon="mdi-content-duplicate"
          :text="`${tab=='dup1'?'Saisir la réference à duppliquer':'Saisir la nouvelle référence'}`"
          title="Dupplication"
        >
        <v-card-text>
            <v-tabs-window v-model="tab" >
                <v-tabs-window-item value="dup1">
                    <v-card >
                        <div class="input-group input-group-sm mb-3">
                            <input size="5"  v-model="rechercherArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
                        </div>
                        <div v-if="rechercherArticleStatut.statut" style="text-align: center;color: red;">
                            <p>{{ rechercherArticleStatut.msg }}</p>
                        </div>
                    </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="dup2">
                    <v-card >
                        <div class="input-group input-group-sm mb-3">
                            <input size="5"  v-model="duppliquerArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
                        </div>
                        <div v-if="duppliquerArticleStatut.statut" style="text-align: center;color: red;">
                            <p>{{ duppliquerArticleStatut.msg }}</p>
                        </div>
                    </v-card> 
                </v-tabs-window-item>
            </v-tabs-window>
            </v-card-text>
          <template v-slot:actions>
            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="dupplicateDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
                <v-btn v-if="tab=='dup1'"
                    color="green"
                    text="Valider"
                    @click="checkingRefToDupp()"
                    variant="plain"
                ></v-btn>
                <v-btn v-if="tab=='dup2'"
                    color="green"
                    text="valider"
                    @click="dupplicateReference()"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="deleteDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="$error"
          :text="`${articleToDelete.type=='date'?'Vous voulez vraiment supprimer la date '+articleToDelete.art+' ?':(articleToDelete.type=='color'?'Vous voulez vraiment supprimer la couleur '+articleToDelete.art.couleur+' ?':'Vous voulez vraiment supprimer la référence '+articleToDelete.art.reference_y2+' ?')}`"
          title="Suppression"
        >
          <template v-slot:actions>

            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="deleteDialog = false"
                    variant="plain"
                    color="green"
                ></v-btn>
                <v-btn
                    color="red"
                    text="Supprimer"
                    @click="supprimer();deleteDialog = false"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>
        <div class="text-center pa-4">
      <v-dialog
        v-model="statDialog"
        width="700"
      >
        <v-card>
            <Pie   :data="chartData" :options="chartOptions" />
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="commandeNotExist.exist"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="$error"
          :text="commandeNotExist.new=='rien'?`La commande numéro ${commandeNotExist.numero} n'existe pas`:(commandeNotExist.new=='new'?`La commande numéro ${commandeNotExist.numero} a été créé`:`La commande numéro ${commandeNotExist.numero} a été importé`)"
          title="Commande pas trouvé"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="commandeNotExist.exist = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="repartDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="mdi-book-edit"
          :text="`${articleRepart.type=='color'?'Modification de la répartition couleur ':'Modification de la répartition de la référence '}`"
          title="Répartition"
        >
            <v-card style="overflow-y: auto;">
                <v-container class="bg-lightblue py-6" style="max-width: 500px;" >
                    <v-card elevation="2" class="pa-4" >
                    <v-card-title class="text-subtitle-1"></v-card-title>
                        <v-row dense>
                            <v-col cols="3" v-for="etab in fields">
                                <v-text-field
                                    :label="etab.code"
                                    v-model="articleRepart.art.repart[etab.code]"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    class="field"
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
          <template v-slot:actions>

            <v-card-actions >
                <v-btn
                    text="Fermer"
                    @click="repartDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
                
                <v-btn 
                    color="success"
                    text="Valider"
                    @click="setRepart();repartDialog = false"
                    variant="plain"
                ></v-btn>
                
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <!-- <div class="text-center pa-4">
      <v-dialog
          v-model="authentification"
          width="auto"
      >
          <v-card
          max-width="400"
          prepend-icon="$error"
          :text="Veuillez"
          title="Commande pas trouvé"
          >
          <template v-slot:actions>
              <v-btn
              class="ms-auto"
              text="Ok"
              @click="commandeNotExist.exist = false"
              ></v-btn>
          </template>
          </v-card>
      </v-dialog>
    </div> -->
</template>
<script setup>
    import { reactive, onMounted, ref, computed, watch, toRaw } from 'vue'
    import axios from 'axios'
    import store from './store'
    import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    } from 'chart.js'
    import { Pie } from 'vue-chartjs'
    let deleteDialog=ref(false)
    let srcImage=ref()
    let imageDialog=ref(false)
    let commandeNotExist=ref({exist:false,numero:''})
    let statDialog=ref(false)
    let EAN13Choice=ref(false)
    let qteDateLivraison=(article)=>{
        let qte=0
        for( let date in store.state.dateLivraisons){
            if(article[store.state.dateLivraisons[date]].qte){
                qte+=Number(article[store.state.dateLivraisons[date]].qte)
            }  
        }
        return Number(qte)
    }
    function addDateLivraison (date){
        date=date.replace(/-/g, '')
        let datetab=store.state.dateLivraisons
        if(!datetab.find(el=>el==date)){
            datetab.push(date)
            store.commit('addDateLivraison',datetab)
            for(let th in store.state.frep.articles){
                for(let ref in store.state.frep.articles[th]){
                    for(let cab in store.state.frep.articles[th][ref]){
                        store.state.frep.articles[th][ref][cab]={
                            ...store.state.frep.articles[th][ref][cab],
                            [date]:{qte:0,export:false}
                        }
                    }
                }
            }
        }else{
            //console.log('la date exite déjà');
            
        }      
    }
    function excelDateToYYYYMMDD(excelDate) {
        // Excel commence au 1er janvier 1900
        const startDate = new Date(1900, 0, 1);
        // Excel compte le 29 février 1900 (qui n'a jamais existé), donc on retire 1 jour
        const realDate = new Date(startDate.getTime() + (excelDate - 2) * 86400000);
        const year = realDate.getFullYear();
        const month = String(realDate.getMonth() + 1).padStart(2, '0'); // getMonth() est 0-indexé
        const day = String(realDate.getDate()).padStart(2, '0');

        return `${year}${month}${day}`;
    }
    let filtreParams=ref({
        etablissement: [] ,
        code_acheteur: null ,
        code_pole: null ,
        code_marque: '731 - ETRIER',
        code_theme:null ,
        code_rayon: null ,
        code_famille: null ,
        code_sousfamille: null ,
        reference:null ,
        collection: null ,
        enStock : null,
        monStock : null
    })
    async function checkingRefToDupp(){
        if(rechercherArticle.value.length!=12){
            
            rechercherArticleStatut.value.statut=true
            rechercherArticleStatut.value.msg=`La référence n'est pas en bon format`
        }else{
            tab.value='dup2'
        }
    }
    let marque=ref()
    watch(marque,()=>{
        store.commit('addmarque',marque.value)
    })
    function validerModifRef(){
        //console.log(newRef.value);
    }
    let modifRef=ref(false)
    async function dupplicateReference(){
        if(duppliquerArticleStatut.value.length!=12){
            for (let theme in store.state.articles[store.state.marque]){
                for(let ref in store.state.articles[store.state.marque][theme]){
                    if(ref==duppliquerArticle.value){
                        duppliquerArticleStatut.value={statut:true,msg:"La nouvelle référence existe déjà!"}
                        return
                    }else if(ref==rechercherArticle.value){
                        for(let cab in store.state.articles[store.state.marque][theme][ref]){
                            store.state.articles[store.state.marque][theme]={
                                ...store.state.articles[store.state.marque][theme],
                                [duppliquerArticle.value]:{
                                    ...store.state.articles[store.state.marque][theme][duppliquerArticle.value],
                                    [newCAB.value]:{
                                        ...store.state.articles[store.state.marque][theme][ref][cab],
                                        "reference_y2":duppliquerArticle.value,
                                        "codebarre":newCAB.value,
                                        "ean13_y2":'',
                                        "imagename":'',
                                        "new":'nouveau'
                                    }
                                }   
                            }
                            articleToAdd.value=Object.assign({
                                ...store.state.articles[store.state.marque][theme][ref][cab],
                                "reference_y2":duppliquerArticle.value,
                                "codebarre":newCAB.value,
                                "ean13_y2":'',
                                "imagename":'',
                                "new":'nouveau'
                            },dateObject.value)
                            articleToAddTab.value.push(Object.assign({
                                ...store.state.articles[store.state.marque][theme][rechercherArticle.value][cab],
                                "reference_y2":duppliquerArticle.value,
                                "codebarre":newCAB.value,
                                "ean13_y2":'',
                                "imagename":'',
                                "new":'nouveau'
                            },dateObject.value))
                            let val=Number(newCAB.value.substring(3))
                            newCAB.value=`CAB${val+1}`
                        }
                        selectArticle(store.state.articles[store.state.marque][theme][duppliquerArticle.value],theme,duppliquerArticle.value)
                        duppliquerArticle.value=''
                        dupplicateDialog.value=false
                        tab.value="one"
                        dialogAjout.value=true
                        rechercher.value='nouveau'
                        duppliquerArticleStatut.value={statut:false}
                        return
                    }
                }
                duppliquerArticleStatut.value={statut:true,msg:"La référence à duppliquer n'existe pas ou n'est pas en bon format!"}
            }
        }else{
            duppliquerArticleStatut.value={statut:true,msg:"La nouvelle référence n'est pas en bon format!"}
        }
    }
    let dupplicateDialog=ref(false)

    const fields = ref([
        { code: 'MN01', value: '' },
        { code: 'LI02', value: '' },
        { code: 'DK03', value: '' },
        { code: 'FT04', value: '' },
        { code: 'RO06', value: '' },
        { code: 'EN11', value: '' },
        { code: 'HB21', value: '' },
        { code: 'AR09', value: '' },
        { code: 'CO18', value: '' },
        { code: 'BR08', value: '' },
        { code: 'OO10', value: '' },
        { code: 'NP19', value: '' },
        { code: 'GE22', value: '' },
        { code: 'VX05', value: '' },
        { code: 'CA24', value: '' },
        { code: 'PR25', value: '' },
        { code: 'DWEB', value: '' }
    ])
    function repartLigne(repart){
        let ligne=''
        for(let etab in repart){
            if(repart[etab]>0){
                ligne=ligne+`${etab.substring(0,2)}:${repart[etab]},`
            }
            
        }
        return ligne
    }
    let itemsThemes=ref(['FRP-Fripe','PTC-Particulier','LUX-Luxe'])
    let itemsComposition=ref(['03-Cuir','06-Synthétique','44-Textile'])
    let itemsSousFamille=ref(['F1A-sac bandoulière',	'F1B-sac porté épaule',	'F1C-sac porté main',	'F1D-sac banane',	'F1E-sac à dos',	'F1F-sac de cérémomie',	'F1G-sac de soirée',	'F2A-porte-monnaie',	'F2B-portefeuille',	'F2C-porte-chéquier',	'F2D-tout-en-un',	'F2E-porte-clefs',	'F2F-porte-cartes',	'F2G-porte-papiers',	'F2H-étui lunettes',	'F2I-étui cigarettes',	'F2K-étui téléphone',	'F2L-trousse',	'F2M-agenda',	'F2N-étui passeport',	'F3A-gants',	'F3B-parapluie',	'F3C-ceinture',	'F3D-foulard',	'F3E-écharpe',	'F3F-chapeau',	'F3G-porte sac',	'F3H-organiseur de sac',	'F3I-coffret bijoux',	'F3J-coffret cadeau',	'F3K-sac provision à roulettes',	'F3L-sac provision',	'F3M-bijoux',	'F3N-bijoux de sac',	'F3O-bandoulière de sac',	'F3P-bonnet',	'F3Q-étole',	'F3R-masque lavable',	'F3S-Coque téléphone',	'F3T-Casquette',	'F3U-Chaine coque téléphone',	'F3V-Bandoulière coque téléphone',	'F3W-Patch',	'F3X-Adaptateur de telephone'])
    let sousFamilleTabFilter=ref([])
    function filterSousFamille(rayon){
        let regex=new RegExp(`^${rayon}`,'gmi')
        sousFamilleTabFilter.value=sousFamilleTab.value.filter(el=>el.code.match(regex))
    }
    // let frep=ref({
    //     title:{
    //         libelle:'BON DE COMMANDE',
    //         saison:'SPRING - SUMMER 2026',
    //         dateModif:'2025-09-25'
    //     },
    //     fournisseur:{
    //         date:'2025-10-01',
    //         nomClient:'Test',
    //         codeClient:'code_test',
    //         agent:'agent_test',
    //         codeAgent:'code_agent',
    //         libCommande:'testcommande',
    //         etablissement:'NEGO'
    //     },
    //     client:{
    //         enseigne:'enseigne',
    //         raisonSociale:'test',
    //         tvaSiret:'TVA_TEST',
    //         dateLivraison:'2025-10-15',
    //         adresseLiv:'Adresse liv',
    //         adresseFac:'Adresse Fac',
    //         contact:'contact_test',
    //         email:'emailtest',
    //         telephone:'0769',
    //         siteweb:'site',
    //         remarque:'Remarque'
    //     },
    //     fraisPort:20,
    //     remisePied1:10,
    //     remisePied2:0,
    //     articles:{
    //         'ET90':
    //         {
    //             '080-0EMAD013':{
    //                 '1000005926069':
    //                 {
    //                     reference_y2:'080-0EMAD013',
    //                     codebarre:'1000005926069',
    //                     code_couleur:'01',
    //                     couleur:'Noir',
    //                     ean13_y2:'3663779244609',
    //                     code_theme:'ET90',
    //                     theme:'MADRAS',
    //                     marque:'etrier',
    //                     designation:'Porte-cartes',
    //                     code_rayon:'F',
    //                     code_sousfamille:'F1A',
    //                     code_famille:'F1',
    //                     collection:'E25',
    //                     code_composition:'003',
    //                     vte_euro:59,
    //                     achat_euro:25,
    //                     "20251013":{qte:0,export:false},
    //                     qte:0
    //                 }
    //             }
    //         }
    //     },

    //     signature:{exist:false,link:'',file:''}

    // })
    function setRepart(){
        
        if(articleRepart.value.type=='ref'){
            for(let cab in store.state.frep.articles[articleRepart.value.art.code_theme][articleRepart.value.art.reference_y2]){
            store.state.frep.articles[articleRepart.value.art.code_theme][articleRepart.value.art.reference_y2][cab].repart=
            articleRepart.value.art.repart
            }
        }else{
            for(let cab in store.state.frep.articles[articleRepart.value.art.code_theme][articleRepart.value.art.reference_y2]){
            if(store.state.frep.articles[articleRepart.value.art.code_theme][articleRepart.value.art.reference_y2][cab].code_couleur==articleRepart.value.art.code_couleur)
                {
                    store.state.frep.articles[articleRepart.value.art.code_theme][articleRepart.value.art.reference_y2][cab].repart=
                    articleRepart.value.art.repart
                }
            }
        }
        
    }
    function setPrices(type,art,value){
        if(type=='achat_devise_dim'){
            store.state.frep.articles[art.code_theme][art.reference_y2][art.codebarre].achat_euro=(value*(1/rates.value.CurrentRates.rates.USD)).toFixed(2)
        }
        if(type=='achat_devise'){
            for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].achat_devise=value
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].achat_euro=(value*(1/rates.value.CurrentRates.rates.USD)).toFixed(2)
            }
        }
        if(type=='achat_euro'){
            for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].achat_euro=value
            }
        }
        if(type=='vte_euro'){
            for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].vte_euro=value
            }
        }
        if(type=='remise_ligne'){
            for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].remise_ligne=value
            }
        }
        if(type=='prix_promo'){
            for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
                store.state.frep.articles[art.code_theme][art.reference_y2][cab].prix_promo=value
            }
        }
    }
    function setInfoArticles(type,art,value){
        for(let cab in store.state.frep.articles[art.code_theme][art.reference_y2]){
            store.state.frep.articles[art.code_theme][art.reference_y2][cab][type]=value
            if(type=='code_sousfamille'){
               store.state.frep.articles[art.code_theme][art.reference_y2][cab].designation= capitalize(sousFamilleTab.value.find((el)=>{ return el.code==value}).fr)
            }
        }
    }
    let itemsmarques=computed(()=>{return store.state.marques})
    let valid=ref(true)
    let classifications=ref({
        type:'',
        tab:[]
    })
    function capitalize(str) {
        if (!str) return "";
        str = str.trim();
        return str[0].toUpperCase() + str.slice(1);
    }
    function setClassification(type,value){
        setInfoArticles(type.type,type.art,value.code)
        let regex=new RegExp(`^${value.code}`)
        if(type.type=='code_rayon'){
            classifications.value={
                type   : 'code_famille',
                tab    : familleTab.value.filter((el)=>{ return el.code.match(regex)}),
                art    : type.art
            }
        }else if(type.type=='code_famille'){
             classifications.value={
                type   : 'code_sousfamille',
                tab    : sousFamilleTab.value.filter((el)=>{ return el.code.match(regex)}),
                art    : type.art
            }
        }else {
            dialogAjout.value=false
        }
    }
    let rules=(value,libelle,reg)=>{
        let regex = new RegExp(reg)
        // console.log(regex);
        
        if (value){
        if(value.toString().match(regex)){
            valid.value=true
            return [true]
        } else{
            valid.value=false
            return [`Le ${libelle} n'est pas en bon format`]
        }
        }
        else{
        valid.value=false
        return [`Vous devez renseigner le ${libelle}`]
        }
        
    }
    let rules2=(value,libelle,reg)=>{
        let regex = new RegExp(reg)
        if (value){
        if(value.toString().match(regex)){
            valid.value=true
            return [true]
        } else{
            valid.value=false
            return [`Le ${libelle} n'est pas en bon format`]
        }
        }
    }
    let tabDupplicate=ref('one')
    function nouvelleCommande(){
        store.state.frep.articles={
            title:{
                libelle:'BON DE COMMANDE',
                saison:'SPRING - SUMMER 2026',
                dateModif:'2025-09-25'
            },
            fournisseur:{
                date:'2025-10-01',
                nomClient:'Test',
                codeClient:'code_test',
                agent:'agent_test',
                codeAgent:'code_agent',
                libCommande:'testcommande',
                etablissement:'NEGO'
            },
            client:{
                enseigne:'enseigne',
                raisonSociale:'test',
                tvaSiret:'TVA_TEST',
                dateLivraison:'2025-10-15',
                adresseLiv:'Adresse liv',
                adresseFac:'Adresse Fac',
                contact:'contact_test',
                email:'emailtest',
                telephone:'0769',
                siteweb:'site',
                remarque:'Remarque'
            },
            fraisPort:20,
            remisePied1:10,
            remisePied2:0,
            articles:{
                'ET90':
                {
                    '080-0EMAD013':{
                        '1000005926069':
                        {
                            reference_y2:'080-0EMAD013',
                            codebarre:'1000005926069',
                            code_couleur:'01',
                            couleur:'Noir',
                            ean13_y2:'3663779244609',
                            code_theme:'ET90',
                            theme:'MADRAS',
                            marque:'etrier',
                            designation:'Porte-cartes',
                            code_rayon:'F',
                            code_sousfamille:'F1A',
                            code_famille:'F1',
                            collection:'E25',
                            code_composition:'003',
                            vte_euro:59,
                            achat_euro:25,
                            repart:{MN01:1,LI02:3},
                            "20251013":{qte:0,export:false},
                            qte:0
                        }
                    }
                }
            },
            signature:{exist:false,link:'',file:''}
        }
        store.commit('addArticlesFrep',store.state.frep.articles)
    }
    const state = reactive({
        count: 0,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255,255,255)"
            },
            disabled: false
        })
    // Enregistrer les composants de Chart.js nécessaires
    ChartJS.register(Title, Tooltip, Legend, ArcElement)

    // Données du graphique
    
    const chartData = computed(() => ({
        labels: chartData1().tabTheme,
        datasets: [
            {
                label: 'Usage',
                backgroundColor: chartData1().colorTab,
                data: chartData1().tabQte,
            },
        ],
    }))
    let repartDialog=ref(false)
    let articleRepart=ref()
    // Options du graphique
    const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    
    } 
     
    const signature1 = ref(null)
    let colorFilter=ref()
    let authorized=ref(false)
    let tab=ref()
    let dialogAjout=ref(false)
    const panel = ref([0, 1])
    const readonly = ref(false)
    let rechercherArticle=ref()
    let rechercherArticleStatut=ref({statut:false,msg:''})
    let duppliquerArticleStatut=ref({statut:false,msg:''})
    let duppliquerArticle=ref()
    
    function createAlphaCounterFrom(startValue) {
        const MAX = Math.pow(36, 3); // 46656
        if (typeof startValue !== 'string' || !/^[0-9A-Z]{1,3}$/i.test(startValue)) {
            throw new Error("Valeur initiale invalide : doit être une chaîne de 1 à 3 caractères alphanumériques.");
        }
        let count = parseInt(startValue, 36);
        if (isNaN(count) || count >= MAX - 1) {
            throw new Error("Valeur initiale hors limites ou trop proche de 'ZZZ'.");
        }
        return function next() {
            count++; 
            return count.toString(36).toUpperCase().padStart(3, '0');
        };
    }
    let newColor=ref({code_couleur:'',couleur:''})
    function addNewColor(){
        //console.log(couleursTab.value);
        
        if(newColor.value.code_couleur!=''&&newColor.value.couleur!=''){
            colorsToAddTab.value.push(newColor.value)
            colorsToAddTabFilter.value.push(newColor.value)
            colorsToAddTabFilterSelected.value.push(newColor.value)
            if(articleRef.value.code_marque=='969'){
                maxcouleur.value=newColor.value.code_couleur
                newColor.value={
                    code_couleur:createAlphaCounterFrom(maxcouleur.value)(),
                    couleur:'',
                    reference_y2:articleRef.value.reference_y2,
                    codebarre:articleRef.value.codebarre,
                    code_theme:articleRef.value.code_theme
                }
            }else if(couleursTab.value.length>0){
                couleursTab.value.push(newColor.value.code_couleur)
                let couleur=1
                let codecouleur=''
                //console.log(couleursTab.value);
                while(couleursTab.value.find(el=>el==articleRef.value.reference_y2.substring(0,3)+couleur.toString().padStart(3, '0'))){
                    couleur++
                    codecouleur=articleRef.value.reference_y2.substring(0,3)+couleur.toString().padStart(3, '0')
                }
                newColor.value={
                    code_couleur:codecouleur,
                    couleur:'',
                    reference_y2:articleRef.value.reference_y2,
                    codebarre:articleRef.value.codebarre,
                    code_theme:articleRef.value.code_theme
                }
                //console.log(newColor.value);
                
            }else{
                maxcouleur.value=newColor.value.code_couleur
                newColor.value={code_couleur:'',couleur:''}
            }
        }
    }
    function deleteNewColor(color){
        colorsToAddTab.value=colorsToAddTab.value.filter(el=>el.code_couleur!=color.code_couleur)
        colorsToAddTabFilter.value=colorsToAddTab.value.filter(el=>el.code_couleur!=color.code_couleur)
        colorsToAddTabFilterSelected.value=colorsToAddTabFilterSelected.value.filter(el=>el.code_couleur!=color.code_couleur)
    }
    let colorsTabFilter=ref([])
    function goToColor(){        
        if(articleRef.value.code_marque=='969'){
            newColor.value={
                code_couleur:createAlphaCounterFrom(maxcouleur.value)(),
                couleur:rechercher.value,
                reference_y2:articleRef.value.reference_y2,
                codebarre:articleRef.value.codebarre,
                code_theme:articleRef.value.code_theme
            }
        }else if(colorsTabFilter.value.length>0){
            let couleur=1
            let codecouleur=''
            while(colorsTabFilter.value.find(el=>el&&el===`${articleRef.value.reference_y2.substring(0,3)}${couleur.toString().padStart(3, '0')}`)){
                couleur++
                codecouleur=articleRef.value.reference_y2.substring(0,3)+couleur.toString().padStart(3, '0')

            }
            newColor.value={
                code_couleur:codecouleur,
                couleur:rechercher.value,
                reference_y2:articleRef.value.reference_y2,
                codebarre:articleRef.value.codebarre,
                code_theme:articleRef.value.code_theme
            }
        }else{
            let couleur=1
            let codecouleur=`${articleRef.value.reference_y2.substring(0,3)}${couleur.toString().padStart(3, '0')}`
            newColor.value={
                code_couleur:codecouleur,
                couleur:rechercher.value,
                reference_y2:articleRef.value.reference_y2,
                codebarre:articleRef.value.codebarre,
                code_theme:articleRef.value.code_theme
            }
        }
        tab.value='sixe'
    }
        
    let collections=ref(['E23','E24','E25','E26','H23','H24','H25','H26','R23','R24','R25','R26'])
    let articleToAdd=ref()
    function getColorNumber(ref){
        let color=[]
        let taille=[]
        for(let cab in ref){
            if(!color.find((el)=>{return ref[cab].code_couleur==el})){
                color.push(ref[cab].code_couleur)
            }
            if(!taille.find((el)=>{return ref[cab].code_taille==el})){
                taille.push(ref[cab].code_taille)
            }    
        }
        return {color:color.length,taille:taille.length}
    }
    function trierParCouleurEtTaille(tab) {
        return tab.sort((a, b) => {
            // Trier par finded (boolean) - les true d'abord
            if (a.finded !== b.finded) {
                return a.finded ? -1 : 1;
            }

            // Si finded identique, trier par couleur
            const couleurA = a.couleur.toLowerCase();
            const couleurB = b.couleur.toLowerCase();
            
            if (couleurA !== couleurB) {
                return couleurA < couleurB ? -1 : 1;
            }

            // Si couleur identique, trier par taille
            const tailleA = isNaN(a.taille) ? a.taille : Number(a.taille);
            const tailleB = isNaN(b.taille) ? b.taille : Number(b.taille);
            
            if (tailleA !== tailleB) {
                return tailleA < tailleB ? -1 : 1;
            }

            return 0;
        });
    }
    function addArticle(){
        if(calculQte().statut){
        for(let art in articleToAddTabFilter.value){
            if(calculQteColor(articleToAddTabFilter.value[art]).statut){
                qteStatut.value=false
                if(!articleToAddTabFilter.value[art].ean13_y2 || articleToAddTabFilter.value[art].ean13_y2=='' || checkingEAN13(articleToAddTabFilter.value[art].ean13_y2).erreur){
                    EAN13Choice.value=true
                    ean13Statut.value=true
                    return
                }else{
                    ean13Statut.value=false
                    if(!checkingEan13(articleToAddTabFilter.value[art]).statut){
                        checkingEan13Statut.value.statut=false
                        if(!store.state.frep.articles[articleToAddTabFilter.value[art].code_theme]){
                            store.state.frep.articles={
                                ...store.state.frep.articles,
                                [articleToAddTabFilter.value[art].code_theme]: store.state.frep.articles[articleToAddTabFilter.value[art].code_theme]=
                                {...store.state.frep.articles[articleToAddTabFilter.value[art].code_theme],
                                    [articleToAddTabFilter.value[art].reference_y2]:{
                                        [articleToAddTabFilter.value[art].codebarre]:articleToAddTabFilter.value[art]
                                    }
                                }
                            }  
                        }else if(!store.state.frep.articles[articleToAddTabFilter.value[art].code_theme][articleToAddTabFilter.value[art].reference_y2]){               
                            store.state.frep.articles[articleToAddTabFilter.value[art].code_theme]=
                            {...store.state.frep.articles[articleToAddTabFilter.value[art].code_theme],
                                [articleToAddTabFilter.value[art].reference_y2]:{
                                    [articleToAddTabFilter.value[art].codebarre]:articleToAddTabFilter.value[art]
                                }
                            }
                        }else if(!store.state.frep.articles[articleToAddTabFilter.value[art].code_theme][articleToAddTabFilter.value[art].reference_y2][articleToAddTabFilter.value[art].codebarre]){             
                            store.state.frep.articles[articleToAddTabFilter.value[art].code_theme][articleToAddTabFilter.value[art].reference_y2]=
                            {...store.state.frep.articles[articleToAddTabFilter.value[art].code_theme][articleToAddTabFilter.value[art].reference_y2],
                                [articleToAddTabFilter.value[art].codebarre]:articleToAddTabFilter.value[art]
                            }
                        }
                        ean13Tab.value.push(articleToAddTabFilter.value[art])    
                    }else{
                        return
                    }
                }
                
            }
        }
        ean13Statut.value=false
        dialogAjout.value=false
        rechercher.value=''
        }else{
            
            qteStatut.value=true
        }
      
    }
    let qteStatut=ref(false)
    let ean13Statut=ref(false)
    let articleToAddTab=ref([])
    function etatStock(article){
        if(article.stock){
            if(article.stock.DEPO&&article.stock.DEPO>=30){
                return {icon:"$success",color:"success"}
            }else if(article.stock.DEPO&&article.stock.DEPO>=10){
                return {icon:"$info",color:"primary"}
            }else if(article.stock.DEPO&&article.stock.DEPO>=3){
                return {icon:"$info",color:"warning"}
            }else{
                return {icon:"$error",color:"error"}
            }
            
        }else{
            return {icon:"mdi-delete-forever",color:"error"}
        }
        
    }
    function addQte(article){
        for(let art in articleToAddTabFilter.value){
            if(articleToAddTabFilter.value[art].codebarre==article.codebarre){
                articleToAddTabFilter.value[art].qte=0
                for(let date in store.state.dateLivraisons)
                {
                    articleToAddTabFilter.value[art][store.state.dateLivraisons[date]].qte++
                    articleToAddTabFilter.value[art].qte+=articleToAddTabFilter.value[art][store.state.dateLivraisons[date]].qte
                }
            }  
        }
    }
    function calculQte(){
        let articleToAddqte=0
        for(let art in articleToAddTabFilter.value){
            for(let date in store.state.dateLivraisons)
            {
                articleToAddqte+=articleToAddTabFilter.value[art][store.state.dateLivraisons[date]].qte
            }
        }
        return {
            qte:articleToAddqte,
            statut:articleToAddqte>0?true:false
        } 
    }
    function calculQteColor(color){
        let articleToAddqte=0
        for(let date in store.state.dateLivraisons)
        {
            articleToAddqte+=color[store.state.dateLivraisons[date]].qte
        }
        return {
            qte:articleToAddqte,
            statut:articleToAddqte>0?true:false
        } 
    }
    let checkingEan13Statut=ref({statut:false,msg:''})
    function checkingEan13(color){
        let ean=ean13Tab.value.filter(el=>el.ean13_y2==color.ean13_y2 && el.codebarre!=color.codebarre)        
        if(ean.length>0){
            checkingEan13Statut.value.statut=true
            checkingEan13Statut.value.msg=`le EAN13 ${ean[0].ean13_y2} est déjà attribué à la référence: ${ean[0].reference_y2} couleur: ${ean[0].code_couleur}-${ean[0].couleur}${ean[0].taille?' taille :'+ean[0].taille:''}`
            return checkingEan13Statut.value
        }
        return {statut:false,msg:''} 
    }
    function checkingEAN13(cab){
        let ean=cab
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()!=cab&&cab!=''?{erreur:true,color:'red'}: {erreur:false}
    }
    let autoEAN13=ref(100000000000)
    // articleToAddTabFilter
    function generateEAN13(cab){
        let ean=Number(cab)
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()
    }
    function ean13Attribution(color){
        if(!color.ean13_y2 || color.ean13_y2==''){
            autoEAN13.value++
            color.ean13_y2=generateEAN13(autoEAN13.value)
        }
    }
    let articleRef=ref()
    let newRef=ref()
    function selectArticle(article,theme,codeArticle){
        rechercher.value=''
        qteStatut.value=false
        ean13Statut.value=false
        EAN13Choice.value=false
        articleToAddTabFilter.value=[]
        refToCreate.value={msg:'',statut:false}
        rechercherArticleStatut.value={statut:false,msg:''}
        checkingEan13Statut.value={statut:false,msg:''}
        chekingArt.value={statut:false,msg:``}
        taillesToAddTabFilterSelected.value=[]
        colorsToAddTabFilterSelected.value=[]
        
        if(article){
            articleRef.value=article
            if(!article.NEWREF){
                newRef.value={...toRaw(articleRef.value)}
            }
            let regex=new RegExp(`^${articleRef.value.reference_y2?articleRef.value.reference_y2.substring(0,3):''}`,"i")
            colorsTabFilter.value=couleursTab.value.filter(el=>el.match(regex))
        }
        if(codeArticle){
            articleToAddTab.value=[]
            tab.value="one"
            if(!store.state.articles[store.state.marque][theme][codeArticle]){
                newRef.value.codebarre=newCAB.value
                store.state.articles[store.state.marque][theme]={
                    ...store.state.articles[store.state.marque][theme],
                    [codeArticle]:{
                        [newCAB.value]:newRef.value
                    }
                }
            }
            for(let art in store.state.articles[store.state.marque][theme][codeArticle]){
                if(!store.state.articles[store.state.marque][theme][codeArticle][art] || store.state.articles[store.state.marque][theme][codeArticle][art].ean13_y2=='' ){
                    EAN13Choice.value=true
                }
                if(!store.state.frep.articles[theme]){
                    for(let date in store.state.dateLivraisons){
                        store.state.articles[store.state.marque][theme][codeArticle][art]={
                        ...store.state.articles[store.state.marque][theme][codeArticle][art],[store.state.dateLivraisons[date]]:{qte:0,export:false}
                        }
                        
                    }
                    articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                    
                }else{
                    if(!store.state.frep.articles[theme][codeArticle]){
                        for(let date in store.state.dateLivraisons){
                            store.state.articles[store.state.marque][theme][codeArticle][art]={
                            ...store.state.articles[store.state.marque][theme][codeArticle][art],[store.state.dateLivraisons[date]]:{qte:0,export:false}
                            }
                        }
                        articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                    }else{
                        if(!store.state.frep.articles[theme][codeArticle][art]){
                            for(let date in store.state.dateLivraisons){
                                store.state.articles[store.state.marque][theme][codeArticle][art]={
                                ...store.state.articles[store.state.marque][theme][codeArticle][art],[store.state.dateLivraisons[date]]:{qte:0,export:false}
                                }
                            }
                            articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                        }  
                    }
                }        
            }
            // console.log('store3',store.state.articles[store.state.marque][theme][codeArticle]);
            
            articleToAdd.value= store.state.articles[store.state.marque][theme][codeArticle]
            articleToAddTabFilter.value=articleToAddTab.value
            // console.log(articleToAddTabFilter.value);
            
            
        }else{
            if(theme){
                articleToAddTab.value=[]
                tab.value="two"
                articleToAdd.value= store.state.articles[store.state.marque][theme]
                for(let ref in store.state.articles[store.state.marque][theme]  ){
                    if(!store.state.frep.articles[theme]){
                        articleToAddTab.value.push(store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]])
                    }else{
                        if(!store.state.frep.articles[theme][ref]){
                          articleToAddTab.value.push(store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]])  
                        }
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            else{              
                articleToAddTab.value=[]
                tab.value="three"
                articleToAdd.value= store.state.articles[store.state.marque]
                for(let th in store.state.articles[store.state.marque] ){
                    if(!store.state.frep.articles[th]){
                        articleToAddTab.value.push(store.state.articles[store.state.marque][th][Object.keys(store.state.articles[store.state.marque][th])[0]][Object.keys(store.state.articles[store.state.marque][th][Object.keys(store.state.articles[store.state.marque][th])[0]])[0]])
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            
        }
    }
    let colorsToAddTab=ref([])
    let colorsToAddTabFilter=ref([])
    let colorsToAddTabFilterSelected=ref([])
    async function addReference() {
        if(rechercher.value){
            tab.value='seven'
            newRef.value.reference_y2=`${newRef.value.reference_y2.substring(0,3)}-${rechercher.value.trim().toString().toUpperCase().padStart(8, '0')}`
            newRef.value.ref_fourn=rechercher.value
        }else{
            tab.value='seven'
            newRef.value.reference_y2=`${newRef.value.reference_y2.substring(0,3)}-`
            newRef.value.ref_fourn=''
        }
    }
    async function addColor(){
        ean13Statut.value=false
        qteStatut.value=false
        let regex = new RegExp(rechercher.value, "i")
        colorsToAddTabFilterSelected.value=[]
        colorsToAddTabFilter.value=colorsToAddTab.value.sort((a,b)=>{ return a.code_couleur-b.code_couleur}).filter(el=>(`${el.code_couleur}${el.couleur}`).match(regex))
        taillesToAddTabFilter.value=taillesToAddTab.value.sort((a,b)=>{ return a.code_taille-b.code_taille})
    }
    let taillesToAddTab=ref([])
    let taillesToAddTabFilter=ref([])
    let taillesToAddTabFilterSelected=ref([])
    function Addtailles(){
        taillesToAddTabFilterSelected.value=[]
        tab.value='five'
        
    }
    function addSelectedColor(color){
        if(colorsToAddTabFilterSelected.value.filter(el=>el.code_couleur==color.code_couleur).length==0){
            colorsToAddTabFilterSelected.value.push(color)
        }
    }
    function addSelectedtaille(taille){
        if(taillesToAddTabFilterSelected.value.filter(el=>el.code_taille==taille.code_taille).length==0){
            taillesToAddTabFilterSelected.value.push(taille)
        }
    }
    let newCAB=ref('CAB1')
    watch(store.state.dateLivraisons,()=>{
        for(let date in store.state.dateLivraisons){
            dateObject.value={
                ...dateObject.value,
                [store.state.dateLivraisons[date]]:{qte:0,export:false}
            }
        }
    })
         
    function gotTotailles(){
        if(colorsToAddTabFilterSelected.value.length>0){
            tab.value='five'
            chekingArt.value.statut=false
            chekingArt.value.msg=``
        }else{
            chekingArt.value.statut=true
            chekingArt.value.msg=`Veuillez selectionner au moins une couleur`
        }
    }
    let refToCreate=ref({msg:'',statut:false})
    function createReference(){
        for(let ref in store.state.articles[store.state.marque][newRef.value.code_theme]){
            if(newRef.value.reference_y2==ref){
                refToCreate.value.msg=`La référence ${newRef.value.reference_y2} existe déjà`
                refToCreate.value.statut=true
                return
            }
        }
        refToCreate.value={msg:'',statut:false}
        articleRef.value.NEWREF=true
        selectArticle(articleRef.value,newRef.value.code_theme,newRef.value.reference_y2)
        tab.value='four'
    }
    let dateObject=ref({})
    let chekingArt=ref({statut:false,msg:''})
    function chekingArtToAdd(type){
        let artTab={}
        //console.log('newRef',newRef.value)
        // console.log('Object.keys(articleRef.value)[0]',Object.keys(articleRef.value)[0])
        if(Object.keys(articleRef.value).length>2){
            artTab=articleRef.value
            artTab=store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2]
            // store.state.articles[store.state.marque][articleRef.value[Object.keys(articleRef.value)[0]].code_theme][articleRef.value[Object.keys(articleRef.value)[0]].reference_y2]
        }else{
            if(newRef.value.reference_y2!=''){
                artTab=store.state.articles[store.state.marque][articleRef.value.code_theme][newRef.value.reference_y2]
            }else{
                artTab=store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2]
            }             
        }
        if(type=='color'){
            if(colorsToAddTabFilterSelected.value.length>0){    
                for(let art in artTab){
                    for (let color in colorsToAddTabFilterSelected.value){
                        //console.log('artTab[art]',artTab[art])
                        if(artTab[art].code_couleur==colorsToAddTabFilterSelected.value[color].code_couleur){
                            chekingArt.value.statut=true
                            chekingArt.value.msg=`la couleur ${colorsToAddTabFilterSelected.value[color].code_couleur}-${colorsToAddTabFilterSelected.value[color].couleur} existe déjà pour la ref ${articleRef.value.reference_y2}`
                            return 
                        }
                    }
                }
            }else{
                chekingArt.value.statut=true
                chekingArt.value.msg=`Veuillez selectionner au moins une couleur`
                return 
            }
        }else if(type=='taille'){
            if(taillesToAddTabFilterSelected.value.length>0){
                for(let art in artTab){
                    for (let color in colorsToAddTabFilterSelected.value){
                        for (let taille in taillesToAddTabFilterSelected.value){
                            if(artTab[art].code_couleur==colorsToAddTabFilterSelected.value[color].code_couleur && artTab[art].code_taille==taillesToAddTabFilterSelected.value[taille].code_taille){
                                chekingArt.value.statut=true
                                chekingArt.value.msg=`la couleur ${colorsToAddTabFilterSelected.value[color].code_couleur}-${colorsToAddTabFilterSelected.value[color].couleur} et la taille ${taillesToAddTabFilterSelected.value[taille].taille} existent déjà pour la ref ${articleRef.value.reference_y2}`
                                return 
                            }
                        }
                        
                    }
                }
            }else{
                chekingArt.value.statut=true
                chekingArt.value.msg=`Veuillez selectionner au moins une taille`
                return
            }
        }
        chekingArt.value={statut:false,msg:''}
        AddEAN13toNewColor ()
        
    }
    
    function AddEAN13toNewColor (){
        articleToAddTab.value=[]
        if(newRef.value.reference_y2!=''){
            articleRef.value=newRef.value
        }
        taillesToAddTabFilterSelected.value=taillesToAddTabFilterSelected.value.length>0?taillesToAddTabFilterSelected.value:[{code_taille:'',taille:''}]
        for (let color in colorsToAddTabFilterSelected.value){
            for(let taille in taillesToAddTabFilterSelected.value){
                if(store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2]){
                    store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2]=
                    {
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2],
                        [newCAB.value]:{
                            ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                            "codebarre":newCAB.value,
                            "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                            "taille":taillesToAddTabFilterSelected.value[taille].taille,
                            "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                            "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                            "ean13_y2":'',
                            "new":'nouveau'
                        }
                    }
                    articleToAdd.value=Object.assign({
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                        "codebarre":newCAB.value,
                        "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                        "taille":taillesToAddTabFilterSelected.value[taille].taille,
                        "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                        "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                        "ean13_y2":'',
                        "new":'nouveau'
                    },dateObject)  
                    articleToAddTab.value.push(Object.assign({
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                        "codebarre":newCAB.value,
                        "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                        "taille":taillesToAddTabFilterSelected.value[taille].taille,
                        "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                        "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                        "ean13_y2":'',
                        "new":'nouveau'
                    },dateObject)
                )

                }else{
                    store.state.articles[store.state.marque][articleRef.value.code_theme]={
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme],
                        [articleRef.value.reference_y2]:{
                            ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2],
                            [newCAB.value]:{
                                ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                                "codebarre":newCAB.value,
                                "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                                "taille":taillesToAddTabFilterSelected.value[taille].taille,
                                "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                                "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                                "ean13_y2":'',
                                "new":'nouveau'
                            }
                        }   
                    }
                    articleToAdd.value=Object.assign({
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                        "codebarre":newCAB.value,
                        "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                        "taille":taillesToAddTabFilterSelected.value[taille].taille,
                        "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                        "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                        "ean13_y2":'',
                        "new":'nouveau'
                    },dateObject)
                    articleToAddTab.value.push(Object.assign({
                        ...store.state.articles[store.state.marque][articleRef.value.code_theme][articleRef.value.reference_y2][articleRef.value.codebarre],
                        "codebarre":newCAB.value,
                        "code_taille":taillesToAddTabFilterSelected.value[taille].code_taille,
                        "taille":taillesToAddTabFilterSelected.value[taille].taille,
                        "code_couleur":colorsToAddTabFilterSelected.value[color].code_couleur,
                        "couleur":colorsToAddTabFilterSelected.value[color].couleur,
                        "ean13_y2":'',
                        "new":'nouveau'
                    },dateObject))
                }
                let val=Number(newCAB.value.substring(3))
                newCAB.value=`CAB${val+1}`
            }
        }
        articleToAddTabFilter.value=articleToAddTab.value
        tab.value="one"
        selectArticle(articleToAdd.value,articleToAdd.value.code_theme,articleToAdd.value.reference_y2)
        rechercher.value='nouveau'
        colorsToAddTabFilterSelected.value=[]
        taillesToAddTabFilterSelected.value=[]
    }

    let articleToDelete=ref()
    function supprimer(){
        if(articleToDelete.value.type=='date'){
            if(store.state.dateLivraisons.length>1){
                store.state.dateLivraisons=store.state.dateLivraisons.filter((el)=> el.toString()!=articleToDelete.value.art)
                store.commit('addDateLivraison',store.state.dateLivraisons)
            }
        }
        else if(articleToDelete.value.type=='color'){
            if(Object.keys(store.state.frep.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2]).length>1){
            delete store.state.frep.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2][articleToDelete.value.art.codebarre];
        }else{
            if(Object.keys(store.state.frep.articles[articleToDelete.value.art.code_theme]).length>1){
                delete store.state.frep.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(store.state.frep.articles).length>1){
                    delete store.state.frep.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        }else{
            if(Object.keys(store.state.frep.articles[articleToDelete.value.art.code_theme]).length>1){
                delete store.state.frep.articles[articleToDelete.value.art.code_theme][articleToDelete.value.art.reference_y2];
            }else{ 
                if(Object.keys(store.state.frep.articles).length>1){
                    delete store.state.frep.articles[articleToDelete.value.art.code_theme]
                }
            }
        }
        
    }
    function totaleQte(params) {
        let qte=0
        for (let el in params){
            qte+=Number(params[el].qte)
        }
        return qte
    }
    function totaleHt(params) {
        let totale=0
        for (let el in params){
            totale+=Number(params[el].qte)*params[el].achat_euro
        }
        return totale.toFixed(2)
    }
    function totaleTheme(params,dateToGate) {
        let qte=0
        let totalht=0
        let totalhtremise=0
        for(let el in params){
            for (let el1 in params[el]){
                for(let date in store.state.dateLivraisons) {
                    if(dateToGate){
                        if(dateToGate==store.state.dateLivraisons[date]){
                            if(params[el][el1][store.state.dateLivraisons[date]]){
                                qte+=Number(params[el][el1][store.state.dateLivraisons[date]].qte)
                                totalht+=Number(params[el][el1][store.state.dateLivraisons[date]].qte)*params[el][el1].achat_euro
                            }
                            
                        }
                    }
                    else{
                        if(params[el][el1][store.state.dateLivraisons[date]]){
                            qte+=Number(params[el][el1][store.state.dateLivraisons[date]].qte)
                            totalht+=Number(params[el][el1][store.state.dateLivraisons[date]].qte)*params[el][el1].achat_euro
                            totalhtremise+=(1-store.state.frep.remisePied1/100)*Number(params[el][el1][store.state.dateLivraisons[date]].qte)*params[el][el1].achat_euro
                        }
                   }
                }
            }
        }
        return {qte:qte,totalht:totalht.toFixed(2),totalhtremise:totalhtremise.toFixed(2)}
    }
    function totalRef(params,dateToGate) {
        let qte=0
        let totalht=0
        let totalhtremise=0
        // for(let el in params){
            for (let el1 in params){
                for(let date in store.state.dateLivraisons) {
                    if(dateToGate){
                        if(dateToGate==store.state.dateLivraisons[date]){
                            if(params[el1][store.state.dateLivraisons[date]]){
                                qte+=Number(params[el1][store.state.dateLivraisons[date]].qte)
                                totalht+=Number(params[el1][store.state.dateLivraisons[date]].qte)*params[el1].achat_euro
                            }
                            
                        }
                    }
                    else{
                        if(params[el1][store.state.dateLivraisons[date]]){
                        qte+=Number(params[el1][store.state.dateLivraisons[date]].qte)
                        totalht+=Number(params[el1][store.state.dateLivraisons[date]].qte)*params[el1].achat_euro
                        totalhtremise+=(1-store.state.frep.remisePied1/100)*Number(params[el1][store.state.dateLivraisons[date]].qte)*params[el1].achat_euro
                        }
                    }
                }
            }
        // }
        return {qte:Number(qte),totalht:totalht.toFixed(2),totalhtremise:totalhtremise.toFixed(2)}
    }
    function totaleHtCde(params) {
        let totale=0
        for(let el in params){
            for (let el1 in params[el]){
                totale+=Number(params[el][el1].qte)*params[el][el1].achat_euro
            }
        }
        return totale.toFixed(2)
    }
    function updateExportDateQte(){
        let params=store.state.frep.articles
        for(let el in params){
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    for(let date in store.state.dateLivraisons){
                        if(params[el][el1][el2][store.state.dateLivraisons[date]].qte!=0){
                           params[el][el1][el2][store.state.dateLivraisons[date]].export=true
                        }
                    }
                }
                
            }
        }
        store.commit('addArticlesFrep',params)
    }
    function totalCommande(params) {
        let totalht=0
        let qte=0
        for(let el in params){
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    for(let date in store.state.dateLivraisons){
                        if(params[el][el1][el2][store.state.dateLivraisons[date]]){
                            qte+=Number(params[el][el1][el2][store.state.dateLivraisons[date]].qte)
                            totalht+=Number(params[el][el1][el2][store.state.dateLivraisons[date]].qte)*params[el][el1][el2].achat_euro
                        }
                    }
                }
                
            }
        }
        return {
            totalht:totalht.toFixed(2),
            qte:qte
        }
    }
    function chartData1() {
        const colorPalette = [
            "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
            "#FF9F40", "#E7E9ED", "#FF6B6B", "#6BCB77", "#FFD93D",
            "#845EC2", "#D65DB1", "#FF6F91", "#FF9671", "#FFC75F",
            "#F9F871", "#2C73D2", "#0081CF", "#0089BA", "#008E9B",
            "#008F7A", "#B39CD0", "#FFAAA5", "#FCF6BD", "#D0F4DE",
            "#A9DEF9", "#E4C1F9", "#FFCAD4", "#B5EAD7", "#C7CEEA"
        ];  
        let tab=[]
        let colorTab=[]
        let tabQte=[]
        let i=0
        let qte=0
        let params=store.state.frep.articles
        for(let el in params){
            tab.push(params[el][Object.keys(params[el])[0]][Object.keys(params[el][Object.keys(params[el])[0]])[0]].theme)
            
            colorTab.push(colorPalette[i])
            i++
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    qte=Number(qte)+Number(qteDateLivraison(params[el][el1][el2]))
                } 
            }
            tabQte.push(qte),
            qte=0
        }
        // console.log({tabTheme:tab,colorTab:colorTab,tabQte:tabQte});
        
        return {tabTheme:tab,colorTab:colorTab,tabQte:tabQte}
    }
    const save = (t) => {
        store.state.frep.signature.exist=true
        store.state.frep.signature.link=signature1.value.save(t)      
    }
    let rechercher=ref()
    let articleToAddTabFilter=ref([])
    watch(rechercher,()=>{
        let regex = new RegExp(rechercher.value, "i")
        if(tab.value=='one'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code_couleur}${el.couleur}${el.codebarre}${el.ean13_y2}${el.new?el.new:''}`).match(regex))
        }else if(tab.value=='four'){
            colorsToAddTabFilter.value=colorsToAddTab.value.filter(el=>(`${el.code_couleur}${el.couleur}`).match(regex))
        }else if(tab.value=='two'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.reference_y2}${el.designation}${el.ref_fourn}`).match(regex))
        }else if(tab.value=='three'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code_theme}${el.theme}`).match(regex))
        }  
    })
    // watch(articleToAddTabFilter,()=>{
    //    //console.log(articleToAddTabFilter.value);
       
    // })
    let articleFinded=ref()
    function getArticle(){
        articleFinded.value=''
        for (let theme in store.state.articles[store.state.marque]){
            for(let ref in store.state.articles[store.state.marque][theme]){
                if(ref==rechercherArticle.value){
                    selectArticle(store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]],theme,ref)
                    rechercherArticle.value=''
                    rechercherArticleStatut.value={statut:false}
                    return
                }
                for(let cab in store.state.articles[store.state.marque][theme][ref]){
                    if(cab==rechercherArticle.value || rechercherArticle.value==store.state.articles[store.state.marque][theme][ref][cab].ean13_y2){                    
                        store.state.articles[store.state.marque][theme][ref][cab]={
                            ...store.state.articles[store.state.marque][theme][ref][cab],finded:true
                        }
                        // articleToAdd.value={[cab]:
                        //     {
                        //     ...store.state.articles[store.state.marque][theme][ref][cab],qte:1
                        //     }
                        // }
                        // for(let date in store.state.dateLivraisons){
                        //     articleToAdd.value[cab]={
                        //         ...articleToAdd.value[cab],[store.state.dateLivraisons[date]]:{qte:0,export:false}
                                
                        //     }
                        // }
                        // // console.log(articleToAdd.value);
                        
                        // articleToAddTabFilter.value.push(articleToAdd.value[cab])
                        // addArticle()
                        // dialogAjout.value=false
                        articleFinded.value=rechercherArticle.value
                        selectArticle(store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]],theme,ref)
                        rechercherArticle.value=''
                        rechercherArticleStatut.value={statut:false}
                        return
                    }
                }
            }
        }
        rechercherArticleStatut.value={statut:true,msg:"L'article n'existe pas!"}
    }
    
    function trierObjetParcouleurEttaille(obj) {
        const entries = Object.entries(obj);
        entries.sort(([, a], [, b]) => {
            // const findedA=a.finded
            // const findedB=a.finded
            // if (findedA < findedB) return -1;
            // if (findedA > findedB) return 1;

            const couleurA = a.couleur.toLowerCase();
            const couleurB = b.couleur.toLowerCase();

            if (couleurA < couleurB) return -1;
            if (couleurA > couleurB) return 1;
            const tailleA = parseInt(a.taille, 10);
            const tailleB = parseInt(b.taille, 10);

            return tailleA - tailleB;
        });
        const sortedObj = Object.fromEntries(entries);
        return sortedObj;
    }
    let couleursTab=ref([])
    let ean13Tab=ref([])
    let daysRate=ref('20251119')
    let rates=ref()
    function getLibelleFournisseur(element,niv) {
      // Parcours de l'objet imbriqué jusqu'au champ FOURNISSEUR
      const niveau1 = Object.values(element)[0]; // "231"
      const niveau2 = Object.values(niveau1)[0];       // "AA060"
      const niveau3 = Object.values(niveau2)[0];       // "350-2158-424"
      const niveau4 = Object.values(niveau3)[0];
      const niveau5 = Object.values(niveau4)[0];
      if(niv==1){
        return niveau5
      }else{
        return niveau4
      }
             return niv==1?niveau5:niveau4;
    //   return niveau4
    }
    async function getCurrencyRates(){
        let params=
        {   
            days:daysRate.value
        }
        let url=    `https://my.edisac.com/api/getrates`
        let config = {
        method: 'get',
        url: url,
        params:params
        };
        return   axios.request(config)
        .then((response) => {
            rates.value=response.data
            //console.log(response.data);
            
        })
    }
    async function getArticles(){
        // console.log(filtreParams.value.code_marque.split(" - ").splice(0,1));
        
        colorsToAddTab.value=[]
        colorsToAddTabFilter.value=[]
        colorsToAddTabFilterSelected.value=[]
        taillesToAddTab.value=[]
        taillesToAddTabFilter.value=[]
        taillesToAddTabFilterSelected.value=[]
        store.commit('updateWaiting')
        let params=
        {   
            marques:`{${filtreParams.value.code_marque.split(" - ").splice(0,1)}}` //`{${filtreParams.value.code_marque.map(x=>x=x.split("-")[0].trim())}
        }
        let url=    `https://my.edisac.com/goapi/articlesdeep`
        let config = {
        method: 'get',
        url: url,
        params:params
        };
        //console.log(config);
        
        return   axios.request(config)
        .then((response) => {
            console.log(response.data.articles);
            
            store.commit('addArticles',response.data.articles) 
            taillesToAddTab.value=response.data.taillesToAddTab
            colorsToAddTab.value=response.data.colorsToAddTab
            taillesToAddTabFilter.value=response.data.taillesToAddTab.sort((a,b)=>{ return a.code_taille-b.code_taille})
            colorsToAddTabFilter.value=response.data.colorsToAddTab.sort((a,b)=>{ return a.couleur-b.couleur})
            maxcouleur.value=response.data.maxcouleur
            ean13Tab.value=response.data.ean13Tab
            for(let date in store.state.dateLivraisons){
                dateObject.value={
                    ...dateObject.value,
                    [store.state.dateLivraisons[date]]:{qte:0,export:false}
                }
            }
            store.commit('addSingleArticlesFrep',Object.assign({...response.data.articles[getLibelleFournisseur(response.data.articles,2).code_marque][getLibelleFournisseur(response.data.articles,2).code_theme][getLibelleFournisseur(response.data.articles,2).reference_y2][getLibelleFournisseur(response.data.articles,2).codebarre]},dateObject.value))
            store.commit('updateWaiting')
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }
    let maxcouleur=ref()
    async  function sendImages(){
       if(store.state.frep.signature.exist){
            let data = {
                reception:Math.round(new Date().getTime() / 1000),
                signature:store.state.frep.signature.link,
                }
            let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/upload',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
            }
            return axios.request(config)
            .then((response) => { 
                
                store.state.frep.signature.file=response.data.signature        
            })
            .catch((error) => {
            //console.log(error);
            });
       }
    }
    let numneg=ref()
    async function getCommandeNegoce (numnegtoget){
        store.commit('updateWaiting')
        let url=    `https://my.edisac.com/api/frep`
        let config = {
        method: 'get',
        url: url,
        params:{numero:numnegtoget}
        };
        return   axios.request(config)
        .then((response) => {
            store.commit('updateWaiting')
            if(response.data.exist){
                
                store.state.frep=response.data
                commandeNotExist.value={exist:true,numero:numnegtoget,new:'old'}
            }else{
                commandeNotExist.value={exist:true,numero:numnegtoget,new:'rien'}
            }
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async function getColors (){
        let url=    `https://my.edisac.com/api/colors`
        let config = {
        method: 'get',
        url: url,
        };
        return   axios.request(config)
        .then((response) => {
            couleursTab.value=response.data
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    let rayonTab=ref([])
    let familleTab=ref([])
    let sousFamilleTab=ref([])
    async function getClassification (){
        let url=    `https://my.edisac.com/api/classificationfripe`
        let config = {
        method: 'get',
        url: url,
        };
        return   axios.request(config)
        .then((response) => {
            rayonTab.value=response.data.rayon
            familleTab.value=response.data.famille
            sousFamilleTab.value=response.data.sousFamille
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async function sendCommandeFrep(){
        await sendImages()
        
        let data = {...store.state.frep, dateLivraisons:store.state.dateLivraisons} 
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'http://localhost:8282/apimyedisac/freparticles',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        }
        //console.log(data);
        
        return axios.request(config)
        .then((response) => { 
            // console.log(response.data);
            updateExportDateQte()
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    function getarticlefrep(){
        // store.state.frep.articles=store.state.frep
        // console.log('frep',store.state.frep.articles);
    }
    const typePromoPBG = ref({
        'color': 'blue',
        'cursor': 'pointer'
    })
    
    onMounted(()=>{
        // getarticlefrep()
        // store.state.frep.articles=store.state.frep
        // console.log('frep',store.state.frep);
        
        getArticles()
        // getColors ()
        getClassification ()
        getCurrencyRates()
    })
    
</script>
<style>
.v-expansion-panel-title{
   height: 10px; 
}
.chart-container {
  width: 600px;    /* Largeur souhaitée */
  height: 100px;   /* Hauteur souhaitée */
  position: relative;
}

.scroll-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 16px;
}
.iconAdd{
cursor: pointer;
}
.iconAdd:hover{
background-color: orange;
}
.iconAddRef{
cursor: pointer;
}
.iconAddRef:hover{
background-color: orange;
}
.iconaddColor{
cursor: pointer;
}
.iconaddColor:hover{
background-color: orange;
}
.entete.sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
  
}
.btn-new {
    position: relative;
    display: inline-block;
    padding: 12px 24px;
    width: 250px;
    text-decoration: none;
    border-radius: 4px;
    font-family: Arial, sans-serif;
    font-weight: bold;
    overflow: hidden;
}

.btn-new::before {
    content: "new";
    position: absolute;
    top: 0px;
    right: -25px;
    background-color: #ff4757;
    color: white;
    padding: 3px 25px;
    font-size: 9px;
    font-weight: bold;
    transform: rotate(45deg);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
.btn-find {
    position: relative;
    display: inline-block;
    padding: 12px 24px;
    width: 250px;
    text-decoration: none;
    border-radius: 4px;
    font-family: Arial, sans-serif;
    font-weight: bold;
    overflow: hidden;
}

.btn-find::before {
    content: "trouvé";
    position: absolute;
    top: 3px;
    right: -25px;
    background-color: green;
    color: white;
    padding: 3px 25px;
    font-size: 9px;
    font-weight: bold;
    transform: rotate(45deg);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}
</style>